import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    Injector,
    Compiler,
    EventEmitter,
    Output,
    NgModuleRef,
    NgModule,
    ViewChild,
    ViewContainerRef,
    ComponentRef,
    Input,
    Inject,
    Pipe,
    PipeTransform,
    HostListener,
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
    ElementRef
} from "@angular/core";
import { Router, RouterModule, ActivatedRoute } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclSideNavItem,
    CclMessageService,
    CclNotifyService,
    CclPopupService,
    CclSharedModule
} from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { SessionService } from "../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import * as mustache from "mustache";
import { SharedModule } from "../../../shared-module/shared-module";
import { CommonModule, DatePipe } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import * as FileSaver from "file-saver";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { CookieService, CookieOptions } from "ngx-cookie";
import { FlashMessagesService } from "angular2-flash-messages";
import * as moment from 'moment';
import 'moment-timezone';
import { cloneDeep, remove, uniq } from "lodash";
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
    selector: "session-section",
    templateUrl: "./session-section.view.html",
    styleUrls: []
})
export class SessionSectionView implements OnInit, AfterViewInit, OnDestroy {
    private sessionList = {};
    private mustache = mustache;
    private output = "";
    private subscription: Subscription;
    private subscription2: Subscription;
    private isPreFilterLoaded = 0;

    private highlightedSessionConfig = { labelConfig: {} };
    private promotedSessionConfig = { labelConfig: {} };
    private generalSessionConfig: any = { labelConfig: {} };
    private sessionGroupList: any;
    private keysSession: any;
    private sessionArrangedList: any;
    private highlightedDataConfig: any;
    private promotedDataConfig: any;
    private generalDataConfig: any;
    private timeFilter: any;
    popUpParam:any;
    tempgeneralList:any;
    private scrolling:boolean = false;

    private sessionFilter: any = {};

    private showCarousel = false;
    private highlightedHasSlide: boolean = false;
    private promotedHasSlide: boolean = false;
    private highlightedSession: any = {};
    private promotedSession: any = {};
    private highlightedStyle;
    private promotedStyle;
    private speakerStyle;
    private speakerConfig;
    private speakerHtml = "";
    private bindSpeakerClick = true;
    private speakerClickHandler;
    private viewSpeakerSessionList = false;
    private filters: any = {};
    esPage = 0;
    private loadingList = true;
    private clearGeneralSessionList = false;
    private noSessionsAvailable = false;
    private isLoggedIn: boolean = false;
    private showMySessions: boolean = false;
    private showMyFav: boolean = false;
    private filterConfig: any;
    private buttonConfig: any;
    private userPreferenceCookie: any = null;
    private downloadSpeakerDocument;
    private customFieldDdfRegx = new RegExp("({@ddf.customFieldMap.)(.*?)(?=@)", "g");
    private assetcustomFieldDdfRegx = new RegExp("({#ddf.customFieldMap.)(.*?)(?=#)", "g");
    private prevGroupingLevels = { topLevel: "", secondLevel: "", thirdLevel: "" };
    private currentGroupingLevels = { topLevel: "", secondLevel: "", thirdLevel: "" };
    clientKey = 'an37qd3bszekwxdermx49584';
    highlightedCarousel = [{ content: "<div></div>" }];
    promotedCarousel = [{ content: "<div></div>" }];
    defaultFilters: any = {};
    temppromotedList:any;
    temphighlightedList:any;
    localTimezoneKey = moment.tz.guess(true);
    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true
    };
    styleType;
    timezone: string;
    defaultTimeZoneKey: string;
    defaultCurrencySymbol: string;
    private loginConfig: any;
    instanceCount: any;

    @Output() childEvent = new EventEmitter();

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private attendeeSessionService: AttendeeSessionService,
        private catalogService: CatalogService,
        public compiler: Compiler,
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private datePipe: DatePipe,
        public ngxSmartModalService: NgxSmartModalService,
        private messageService: CclMessageService,
        private notifyService: CclNotifyService,
        private cookieService: CookieService,
        private _flashMessagesService: FlashMessagesService,
        public popupService: CclPopupService,
        private route: ActivatedRoute,
        private sessionService: SessionService,
        private elementRef: ElementRef
    ) {

        this.defaultCurrencySymbol = this.sharedService.event.currencySymbol || this.sharedService.currencySymbol;
        this.defaultTimeZoneKey = this.sharedService.event.timeZoneKey || this.sharedService.timezonekey
        moment.tz.setDefault(this.defaultTimeZoneKey);

        cardpop.dispatcher.on('PopUp',() => {
            this.openCardPopup(cardpop.some_property.modalData,cardpop.some_property.param);
        });

        if (this.cookieService.get("catalog_" + this.sharedService.setup.id) != undefined) {
            this.userPreferenceCookie = JSON.parse(this.cookieService.get("catalog_" + this.sharedService.setup.id));
            this.showHtmlTop = this.userPreferenceCookie.showHtmlTop;
        }

        this.navSecondaryService.includeSave = false;
        this.highlightedSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SESSION.highlighted].config
        );

        this.promotedSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SESSION.promoted].config
        );

        this.speakerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SPEAKER_CONFIG].config
        );

        if(!('enableSpeakerPopup' in this.speakerConfig.catalogConfig)) {
            this.speakerConfig.catalogConfig.enableSpeakerPopup = true;
        }

        this.highlightedDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.highlighted].config
        );

        this.promotedDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.promoted].config
        );
        this.speakerStyle = this.createStyleString2(this.speakerConfig["catalogConfig"].body);

        this.speakerClickHandler = function (event) {
            this.getSessionsBySpeaker();
        };

        this.downloadSpeakerDocument = function(event) {
            event.stopPropagation();
            let documentName = $(event.srcElement).attr("data-filename");
            let documentType = $(event.srcElement).attr("data-documentType");
            let speakerId = $(event.srcElement).attr("data-speakerId");
            let eventId = $(event.srcElement).attr("data-eventId");

            this.attendeeSessionService
                .downloadSpeakerDocument(eventId, documentName, documentType, speakerId)
                .subscribe((resp) => {
                    FileSaver.saveAs(resp.body, documentName);
                });
        };

        if (this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP] != null) {
            this.loginConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);
       }

        this.subscription = this.messageService.getMessage().subscribe((message) => this.listenMessage(message));

        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
            if(!('selectTimezone' in this.filterConfig)) {
                this.filterConfig.selectTimezone = 'browser_timezone';
            }

            if (this.sharedService.event.eventDelivery === 'In Person' && this.filterConfig.isDefaultTimezone == true) {
                this.filterConfig.selectTimezone = 'event_timezone';
            }
        }
        this.sharedService["onScroll"] = this.onScroll.bind(this);
    }

    highlightedLoaded: boolean;
    promotedLoaded: boolean;
    fromAttendee: boolean;
    showHighlighted: boolean = false;
    showPromoted: boolean = false;
    showHtmlTop: boolean = true;

    loadScript() {
        let node = document.createElement('script');
        node.src = 'https://addevent.com/libs/atc/1.6.1/atc.min.js';
        node.type = 'text/javascript';
        node.async = true;
        node.id = 'add-event';
        node.charset = 'utf-8';
        $(document).ready(function(){
            if(document.getElementById('add-event')) {
                if(document.getElementById('ate_css')) {
                    document.getElementById('add-event').parentNode.removeChild(document.getElementById('ate_css'));
                }
                document.getElementById('add-event').parentNode.removeChild(document.getElementById('add-event'));
            }
            document.getElementsByTagName('head')[0].appendChild(node);
        });
        if(this.sharedService.accountClientList) {
            let client = {
                license    : this.clientKey,
                appleical  : {show:this.sharedService.accountClientList.calAppleToggleIcon, text:this.sharedService.accountClientList.calAppleLabel},
                google     : {show:this.sharedService.accountClientList.calGoogleToggleIcon, text:this.sharedService.accountClientList.calGoogleLabel},
                office365  : {show:this.sharedService.accountClientList.calOffice365ToggleIcon, text:this.sharedService.accountClientList.calOffice365Label},
                outlook    : {show:this.sharedService.accountClientList.calOutlookToggleIcon, text:this.sharedService.accountClientList.calOutlookLabel},
                outlookcom : {show:this.sharedService.accountClientList.calOutlookOnlineToggleIcon, text:this.sharedService.accountClientList.calOutlookOnlineLabel},
                yahoo      : {show:this.sharedService.accountClientList.calYahooToggleIcon, text:this.sharedService.accountClientList.calYahooLabel}
            };

            (<any>window).addeventasync = function(){
                (<any>window).addeventatc.settings(client)
            };
        }
    }


    openModal(item) {
        let loggedInUser = sessionStorage.getItem("loggedInAttendee_" + this.sharedService.eventUUID);

        if(loggedInUser == "null" || !loggedInUser) {
            let url = "";
            if (item == "login") {
                this.popupService.setPosition("center");
                this.popupService.setSize("small");
                this.popupService.togglePopup();
                this.sharedService.currentPopup = {
                    title: null,
                    navLinks: null,
                    saveMessage: "reg-login",
                    showFooter: false
                };
                url = "popup/login";
            }
            this.sharedService.navigateToOutlet("popup", url);
        } 
    }

    getLoggedInAttendee() {
        let attendeeUUIDCookie = this.cookieService.get("attendeeUUID_CATALOG_" + this.sharedService.eventUUID);
        if (!this.sharedService.isEmptyString(attendeeUUIDCookie)) {
            this.sharedService.regUUID = attendeeUUIDCookie;
            this.attendeeSessionService.getRegistrationByUUID().subscribe((resp) => {
                let reg = resp.body["registrationDTO"];
                if (reg.id != null && reg.eventId == this.sharedService.event.id) {
                    this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                    sessionStorage.setItem(
                        "loggedInAttendee_" + this.sharedService.eventUUID,
                        JSON.stringify(this.sharedService.loggedInAttendee)
                    );
                    this.attendeeSessionService.getSessionApiOnLogin();
                    this.isLoggedIn = true;
                    this.getAccountclient(this.sharedService.accountUUID);
                    this.esPage = 0;
                    if (this.generalList != null) {
                        this.generalList.clear();
                    }
                    // this.filters.registrationId = this.sharedService.loggedInAttendee.id;
                    this.filters.registrationUUID = this.sharedService.loggedInAttendee.uuid;

                    this.filters["attendeeTypeIds"] = [];
                    this.filters.attendeeTypeIds.push(reg.type.id);

                    this.getSessionList();
                } else {
                    this.getSessionList();
                }
            });
        } else {
            if (this.sharedService.loginWithReUUID ) {
                this.sharedService.loginWithReUUID = false;
                return;
            } else {
            this.getSessionList();
        }
    }
    }

    getAccountclient(accountUUID) {
        this.catalogService.getAccountclient(accountUUID).subscribe((resp:any) => {
            this.sharedService.accountClientList = JSON.parse(resp.body.data);
        })
    }

    setCookie() {
        var d = new Date();
        d.setFullYear(d.getFullYear() + 1);
        var cookieOptions: CookieOptions = {
            expires: d
        };
        var obj: Object = {
            showHighlighted: this.showHighlighted,
            showPromoted: this.showPromoted,
            showHtmlTop: this.showHtmlTop
        };
        this.cookieService.putObject("catalog_" + this.sharedService.setup.id, obj, cookieOptions);
    }

    toggleHighlighted() {
        this.showHighlighted = !this.showHighlighted;
        this.setCookie();
    }

    togglePromoted() {
        this.showPromoted = !this.showPromoted;
        this.setCookie();
    }

    onScroll() {
        if (this.loadingList == false && this.noSessionsAvailable == false && this.esPage > 0) {
            this.filterResults = true;
            this.sharedService.showLoader = false;
            this.loadingList = true;
            this.scrolling = true;
            this.getSessionList();
        }
    }
    @HostListener('click', ['$event'])
    onClick(event) {
        let ID = event.target.id
        if (ID === 'speakerSession'){
            this.getSessionsBySpeaker();
        }
    }


    downloadDocument(eventId, documentName, documentType, sessionId) {
        this.attendeeSessionService
        .downloadSessionDocument(eventId, documentName, documentType, sessionId)
        .subscribe((resp) => {
            FileSaver.saveAs(resp.body, documentName);
        });
    }

    openSpeakerModel(speakerUsername, eventUUID) {
        var speaker;
                this["attendeeSessionService"].getSpeaker(speakerUsername, eventUUID).subscribe(
                    (resp) => {
                        if (resp.hasOwnProperty("body")) {
                            speaker = resp.body;
                            var customFieldMap = {};
                            if (speaker.customFieldCodeMap != null) {
                                Object.keys(speaker.customFieldCodeMap).forEach((key) => {
                                    let keyVal = speaker.customFieldCodeMap[key].split(" : ");
                                    customFieldMap[key.replace(/ /g, "")] = keyVal[1];
                                });
                            }
                            speaker.customFieldMap = customFieldMap;
                            this.popUpParam["speakerStyleStr"] = this.popUpParam["speakerStyleStr"].replace(/,/g, "; ");
                            this.popUpParam["speakerStyleStr"] = this.popUpParam["speakerStyleStr"].replace(/[{}']/g, "");
                            this.popUpParam["speakerStyleStr"] = this.popUpParam["speakerStyleStr"].replace(/,/g, "; ");
                            this.popUpParam["speakerStyleStr"] = this.popUpParam["speakerStyleStr"].replace(/[{}']/g, "");

                            this.popUpParam["speakerTextStyleStr"] = this.popUpParam["speakerTextStyleStr"].replace(/[{}']/g, "");
                            this.popUpParam["speakerTextStyleStr"] = this.popUpParam["speakerTextStyleStr"].replace(/,/g, "; ");
                            this.popUpParam["speakerTextStyleStr"] = this.popUpParam["speakerTextStyleStr"].replace(/,/g, "; ");
                            this.popUpParam["speakerTextStyleStr"] = this.popUpParam["speakerTextStyleStr"].replace(/[{}']/g, "");

                            var output = mustache.render(
                                this.createSpeakercardTemplate(
                                    this.popUpParam["speakerImgStyle"],
                                    this.popUpParam["speakerTextStyleStr"],
                                    this.popUpParam["speakerTemplate"],
                                    speaker,
                                    this.popUpParam["speakerImgBasedOn"],
                                    this.popUpParam["speakerBanner"]
                                ),
                                speaker
                            );

                            const modalData: Object = {
                                speakerModalHeader: this.popUpParam["speakerModalHeader"],
                                modalContent: output,
                                speakerData: {
                                    id: speaker.id,
                                    speakerFirstName: speaker.firstName,
                                    speakerLastName: speaker.lastName
                                }
                            };

                            this.ngxSmartModalService.setModalData(modalData, "myModal", true);
                            this.ngxSmartModalService.open("myModal", false);
                        }
                    },
                    (err) => {
                        const modalData: Object = {
                            modalContent: "Unable to load speaker data"
                        };

                        this.ngxSmartModalService.setModalData(modalData, "myModal", true);
                        this.ngxSmartModalService.open("myModal", false);
                    }
                );
    }

    createSpeakercardTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage) {
        textStyleStr = textStyleStr + ";box-sizing: border-box;padding-right: 15px";
        if (this.popUpParam["speakerLayout"] != "l_noimage" && this.popUpParam["speakerLayout"] != "l_banner") {
            let imagePath = "assets/images/blank_profile.jpg";
            if (imageBasedOn === "speaker_img" && speaker != undefined) {
                if (speaker.avatar != "" && speaker.avatar != null) {
                    imagePath = speaker.avatar;
                }
            }
            if (imageBasedOn === "dynamic_img") {
                if (this.popUpParam["speakerDynamicImg"] != "") {
                    imagePath = this.popUpParam["speakerDynamicImg"];
                }
            }
            return (
                '<div class="attendee-session-list-img-container speaker-catalog-body-container">' +
                '<img alt="Speaker Image" src="' +
                imagePath +
                '" class="speaker-catalog-body-img"></div>' +
                "<div class='attendee-session-list-text-container speaker-catalog-body-text bs-pr' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        } else {
            return (
                (this.popUpParam["speakerLayout"] === "l_banner" && bannerImage != undefined
                    ? '<div><img alt="Banner Image" src="' +
                      bannerImage +
                      '" class="speaker-catalog-body-img"' +
                      "></div>"
                    : "") +
                "<div class='attendee-session-list-text-container speaker-catalog-body-text bs-pr' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        }
    }

    getSessionsBySpeaker() {
        var speaker = this.ngxSmartModalService.getModalData("myModal")["speakerData"];
        this.esPage = 0;
        this.sharedService.speakerFilterApplied = true;
        this.messageService.sendMessage("clear-all-filter");
        this.filters["speakerIds"] = [speaker.id];
        this.filters["trackIds"] = this.defaultFilters.trackIds;
        this.filters["typeIds"] = this.defaultFilters.typeIds;
        this.noSessionsAvailable = false;
        this.clearGeneralSessionList = true;
        this.getSessionList();
    }
   

    onSessionModalClose() {
        
        if (this.vc) {
            this.vc.remove()
        }
    }


    bindClick() {
        this.downloadSpeakerDocument = this.downloadSpeakerDocument.bind(this);
        var customFiles = document.getElementsByClassName("speakerCustomFile");
        if (customFiles != null && customFiles.length > 0) {
            for (let i = 0; i < customFiles.length; i++) {
                customFiles[i].addEventListener("click", this.downloadSpeakerDocument);
            }
            this.bindSpeakerClick = false;
        }

        return false;
    }

    onModalClose() {
        if (this.viewSpeakerSessionList) {
            if (document.getElementsByClassName("speakerCustomFile") != null) {
                var customFiles = document.getElementsByClassName("speakerCustomFile");
                for (let i = 0; i < customFiles.length; i++) {
                    customFiles[i].removeEventListener("click", this.downloadSpeakerDocument);
                }
                this.bindSpeakerClick = false;
            }
            if (this.bindSpeakerClick === true) {
                this.bindSpeakerClick = false;
            }
        }
    }

    onModalOpen() {
        if (this.bindSpeakerClick === false && this.viewSpeakerSessionList) {
            this.bindSpeakerClick = true;
        }
    }

    changeDate(message) {
        if (message.text == "changed-date") {
            this.sessionFilter.startDate = this.datePipe.transform(message.data.selectTab, "dd/mm/yyyy");
            let d = message.data.selectTab.getDate();
            let m = message.data.selectTab.getMonth() + 1;
            let y = message.data.selectTab.getFullYear();
            this.sessionFilter.startDate = d + "/" + m + "/" + y;
            this.sessionFilter.endDate = d + 1 + "/" + m + "/" + y;
            this.getSessionList();
        }
    }

    getPromoMagazineSessions() {
        this.highlightedCarousel = [{ content: "<div></div>" }];
        this.promotedCarousel = [{ content: "<div></div>" }];
        this.highlightedHasSlide = false;
        this.promotedHasSlide = false;
        this.highlightedLoaded = false;
        this.promotedLoaded = false;
        this.getHighlightedAndPromotedSessions();
    }

    listenMessage(message) {
        if (message.text == "apply-session-filters") {
            this.filterResults = true;
            this.clearGeneralSessionList = true;
            this.noSessionsAvailable = false;
            if(message.data.hideFullSession) {
                this.filters.hideFullSessions = true;
            } else {
                delete this.filters.hideFullSessions;
            } 

            if(message.data.hidePastSession) {
                this.filters.hidePastSession = true;
            } else {
                delete this.filters.hidePastSession;
            } 
            this.esPage = 0;
            let cfFilter = {};
            for (let prop in this.sharedService.selectedFilterData) {
                let esProp = "";
                if (prop === "sessionDate") {
                    esProp = "startDates";
                } else if (prop === "track") {
                    esProp = "trackIds";
                } else if (prop === "sessionType") {
                    esProp = "typeIds";
                } else if (prop === "location") {
                    esProp = "locationIds";
                } else if (prop === "speaker") {
                    esProp = "speakerIds";
                } else if (prop === "sessionTime") {
                    esProp = "startTimes";
                } else if (prop === "tag") {
                    esProp = "tagIds";
                } else if (prop === "sessionLevel") {
                    esProp = "sessionLevelIds";
                } else if (prop.indexOf("customField_") > -1) {
                    esProp = "customFieldOptions";
                    cfFilter[prop] = [];
                } else {
                    esProp = prop;
                }
                this.filters[esProp] = [];
                let arr = [];
                for (let prop2 in this.sharedService.selectedFilterData[prop]) {
                    if (this.sharedService.selectedFilterData[prop][prop2] === true) {
                        if (this.sharedService.filterData[prop]) {
                            this.sharedService.filterData[prop].forEach((element) => {
                                if (element.id + "" === prop2) {
                                    if (prop === "sessionDate") {
                                        this.filters[esProp].push(this.datePipe.transform(element.id, "yyyy-MM-dd"));
                                    } else if (prop.indexOf("customField_") > -1) {
                                        cfFilter[prop].push(element.id);
                                    } else if (prop === "sessionTime") { 
                                        if(this.filterConfig.selectTimezone == 'event_timezone' || this.sharedService.timezone == this.sharedService.event.timeZoneKey) {
                                            this.filters[esProp].push(this.convertTime12to24(prop2))
                                        } else {
                                            let pstStartTime = moment(new Date()).tz(this.sharedService.timezone).format();
                                            let temps = pstStartTime.split("T");
                                            let dateSTr = temps[0] + 'T' + this.convertTime12to24(prop2) + temps[1].substr(5);
                                            let time = moment(dateSTr).tz(this.defaultTimeZoneKey).format('hh:mm A');
                                            this.filters[esProp].push(
                                                this.datePipe.transform("Tue Jan 22 2019 " + time, "HH:mm")
                                            );
                                        }
                                    } else {
                                        this.filters[esProp].push(element.id);
                                    }
                                }
                            });
                        }
                    }
                }
            }
            let cfFilter2 = {};
            for (let prop in cfFilter) {
                cfFilter2[prop.replace("customField_", "")] = cfFilter[prop];
            }
            this.filters.customFieldOptions = cfFilter2;
            if (!this.noSessionsInCatalog) {
                this.getSessionList();
            }
        }
        if (message.text == "clear-text-search-field") {
            this.sessionFilter.query = "";
            delete this.filters.sessionName;
        }
        if (message.text == "attendee-login") {
            this.isLoggedIn = true;
            this.esPage = 0;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            // this.filters.registrationId = this.sharedService.loggedInAttendee.id;
            this.filters.registrationUUID = this.sharedService.loggedInAttendee.uuid;
            
            this.noSessionsAvailable = false;
            this.getSessionList();
            this.getPromoMagazineSessions();
        }
        if (message.text == "attendee-logout") {
            this.isLoggedIn = false;
            this.esPage = 0;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            delete this.filters.registrationId;
            delete this.filters.registrationUUID;
            delete this.filters.attendeeTypeIds;
            delete this.filters.fetchFavInstanceList;
            delete this.filters.mySessions;
            this.noSessionsAvailable = false;
            this.getSessionList();
            this.getPromoMagazineSessions();
        }
        if (message.text == "apply-mysession-checkbox") {
            this.mySessionCheckbox();
        }
        if (message.text == "apply-hide-session") {
            this.hideSession(message.data);
        }
        if (message.text == "apply-myfavsession-checkbox") {
            this.myFavCheckbox();
        }
        if (message.text == "apply-mysession-clearAll") {
            this.mySessionFilterClear();
        }

        if (message.text == "apply-my-timezone") {
            this.filters["startDates"] = [];
            this.filters.startTimes = [];
            this.filters.dateRange = [];
            if(message?.data?.text == 'event_timezone') {
                this.filterConfig.selectTimezone = 'event_timezone';
            } else {
                this.filterConfig.selectTimezone = 'browser_timezone';
            }
            this.myTimeZone();
        }
        if (message.text == "apply-session-timezone") {
            this.myTimeZone();
        }

        if (message.text == "toggle-html-top") {
            this.showHtmlTop = message.data;
            this.setCookie();
        }
        if (message.text == "unhide-sessions") {
            this.filters["deleteExcludedAndFetch"] = true;
            this.esPage = 0;
            this.noSessionsAvailable = false;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            this.getSessionList();
        }
        if(message.text == 'hide-past-session') {
            this.esPage = 0
            if (this.generalList != null) {
                this.generalList.clear();
            }
            this.getSessionList();
        }
        if (message.text == 'pre-filter-loaded' && this.sharedService.filterName && this.isPreFilterLoaded < 2) {
            this.isPreFilterLoaded++;
            // Executed when this message is received two times
            // First time: all Standard Fields are loaded in filter section
            // Second time: all Custom Fields are loaded in filter section
            if (this.isPreFilterLoaded == 2) {
                this.setPreFilters();
                this.getLoggedInAttendee();
            }
        }
    }


    convertTime12to24(time12h) {
        const [time, modifier] = time12h.split(' ');
      
        let [hours, minutes] = time.split(':');
      
        if (hours === '12') {
          hours = '00';
        }
      
        if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }
      
        return `${hours}:${minutes}`;
      }

    private filterResults: boolean = false;
    noSessionsInCatalog: boolean = false;
    noHighLightedSessions: boolean = false;
    noPromotedSessions: boolean = false;

    clickTextSearch() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        this.filters["sessionName"] = this.sessionFilter.query;
        this.getSessionList();
    }

    clickRemoveFilter() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        delete this.filters["sessionName"];
        this.sessionFilter.query = '';
        this.getSessionList();
    }

    getHighlightedAndPromotedSessions() {
        let filter = {};
        if (!this.highlightedLoaded && (this.sharedService.catalogLayoutConfig.listType === "magazine" || this.sharedService.catalogLayoutConfig.listType === "magazine")) {
            filter = {};
            if (this.highlightedDataConfig.selectedList != null && this.highlightedDataConfig.selectedList.length > 0) {
                filter["sessionIds"] = this.highlightedDataConfig.selectedList;
                filter["type"] = 'highlighted';
                this.attendeeSessionService.getSessions(filter).subscribe((resp) => {
                    this.highlightedLoaded = true;
                    if (resp.body != null && resp.body["sessions"].length > 0) {
                        var uniqueSessions = [];
                        this.sharedService.updateDateTime(resp.body["sessions"], this.filterConfig.selectTimezone);
                        resp.body["sessions"].forEach((element) => {
                            element.showOtherInstances = false;
                            if(this.instanceCount && this.instanceCount.length > 0) {
                                let index = this.instanceCount.findIndex(object => {
                                    return object.key.toLowerCase() == element.sessionCode.toLowerCase();
                                });
                                if(index >= 0) {
                                    element.showOtherInstances = true;
                                }
                            }
                            if(element.documents && element.documents.length>0) {
                                element.documents.sort(function(a, b) {
                                    return parseInt(a.id) - parseInt(b.id);
                                });
                            }
                            let uniqueSessionIndex = uniqueSessions.findIndex((x) => (x.sessionId == element.sessionId));
                            if (uniqueSessionIndex < 0) {
                                uniqueSessions.push(element);
                            } else {
                                if (element.webinar != null && element.webinar.webinarThumbnail != null && element.webinar.webinarThumbnail.trim().length > 0) {
                                    let existingSession = uniqueSessions[uniqueSessionIndex];
                                    if (existingSession.webinar == null || existingSession.webinar.webinarThumbnail == null || existingSession.webinar.webinarThumbnail.trim().length == 0) {
                                        uniqueSessions[uniqueSessionIndex] = element;
                                    }
                                }
                            }
                        });
                        var sortedUniqueSessions = [];
                        this.highlightedDataConfig.selectedList.forEach((sessionId) => {
                            uniqueSessions.forEach((session) => {
                                if (session.sessionId == sessionId) {
                                    sortedUniqueSessions.push(session);
                                }
                            });
                        });
                        var idx = 0;
                        this.sessionList = {
                            sessions: sortedUniqueSessions,
                            idx: function() {
                                return idx++;
                            },
                            resetIndex: function() {
                                idx -= 1;
                                return;
                            },
                            index: function() {
                                return idx;
                            }
                        };
                        this.highlightedSession = cloneDeep(this.sessionList);
                        this.highlightedStyle = this.createStyleString2(
                            this.highlightedSessionConfig["catalogConfig"].header
                        );
                        if (this.highlightedList != null) {
                            this.highlightedList.clear();
                        }
                        this.listemplateHelper(
                            this.highlightedSessionConfig,
                            this.highlightedList,
                            this.highlightedListRef,
                            "highlighted",
                            this.highlightedDataConfig.displayAs
                        );
                    } else {
                        this.noHighLightedSessions = true;
                    }
                    if (this.userPreferenceCookie != null) {
                        this.showHighlighted = this.userPreferenceCookie.showHighlighted;
                    }
                });
            } else {
                this.noHighLightedSessions = true;
            }
        } else if (this.highlightedLoaded) {
            if (this.highlightedList != null) {
                this.highlightedList.clear();
            }
            this.sessionList = this.highlightedSession;
            this.listemplateHelper(
                this.highlightedSessionConfig,
                this.highlightedList,
                this.highlightedListRef,
                "highlighted",
                this.highlightedDataConfig.displayAs
            );
        }
        if (
            !this.promotedLoaded &&
            (this.sharedService.catalogLayoutConfig.listType === "magazine" ||
                this.sharedService.catalogLayoutConfig.listType === "promoted")
        ) {
            filter = {};
            if (this.promotedDataConfig.selectedList != null && this.promotedDataConfig.selectedList.length > 0) {
                filter["sessionIds"] = this.promotedDataConfig.selectedList;
                filter["type"] = 'promoted';
                this.attendeeSessionService.getSessions(filter).subscribe((resp) => {
                    this.promotedLoaded = true;
                    if (resp.body != null && resp.body["sessions"].length > 0) {
                        var uniqueSessions = [];
                        this.sharedService.updateDateTime(resp.body["sessions"], this.filterConfig.selectTimezone);
                        resp.body["sessions"].forEach((element) => {
                            element.showOtherInstances = false;
                            if(this.instanceCount && this.instanceCount.length > 0) {
                                let index = this.instanceCount.findIndex(object => {
                                    return object.key.toLowerCase() == element.sessionCode.toLowerCase();
                                });
                                if(index >= 0) {
                                    element.showOtherInstances = true;
                                }
                            }

                            if(element.documents && element.documents.length>0) {
                                element.documents.sort(function(a, b) {
                                    return parseInt(a.id) - parseInt(b.id);
                                });
                            }
                            let uniqueSessionIndex = uniqueSessions.findIndex((x) => (x.sessionId == element.sessionId));
                            if (uniqueSessionIndex < 0) {
                                uniqueSessions.push(element);
                            } else {
                                if (element.webinar != null && element.webinar.webinarThumbnail != null && element.webinar.webinarThumbnail.trim().length > 0) {
                                    let existingSession = uniqueSessions[uniqueSessionIndex];
                                    if (existingSession.webinar == null || existingSession.webinar.webinarThumbnail == null || existingSession.webinar.webinarThumbnail.trim().length == 0) {
                                        uniqueSessions[uniqueSessionIndex] = element;
                                    }
                                }
                            }
                        });
                        var sortedUniqueSessions = [];
                        this.promotedDataConfig.selectedList.forEach((sessionId) => {
                            uniqueSessions.forEach((session) => {
                                if (session.sessionId == sessionId) {
                                    sortedUniqueSessions.push(session);
                                }
                            });
                        });
                        var idx = 0;
                        this.sessionList = {
                            sessions: sortedUniqueSessions,
                            idx: function() {
                                return idx++;
                            },
                            resetIndex: function() {
                                idx -= 1;
                                return;
                            },
                            index: function() {
                                return idx;
                            }
                        };
                        this.promotedSession = cloneDeep(this.sessionList);
                        this.promotedStyle = this.createStyleString2(
                            this.promotedSessionConfig["catalogConfig"].header
                        );
                        if (this.promotedList != null) {
                            this.promotedList.clear();
                        }
                        this.listemplateHelper(
                            this.promotedSessionConfig,
                            this.promotedList,
                            this.promotedListRef,
                            "promoted",
                            this.promotedDataConfig.displayAs
                        );
                    } else {
                        this.noPromotedSessions = true;
                    }
                    if (this.userPreferenceCookie != null) {
                        this.showPromoted = this.userPreferenceCookie.showPromoted;
                    }
                });
            } else {
                this.noPromotedSessions = true;
            }
        } else if (this.promotedLoaded) {
            if (this.promotedList != null) {
                this.promotedList.clear();
            }
            this.sessionList = this.promotedSession;
            this.listemplateHelper(
                this.promotedSessionConfig,
                this.promotedList,
                this.promotedListRef,
                "promoted",
                this.promotedDataConfig.displayAs
            );
        }
    }

    getSessionList() {
        
        this.sharedService.generalListLoading = true;
        this.loadingList = true;
        let filter: any = {};

        this.filters["isFilterOverride"] = this.sharedService.clearAllFilterEnabled;
        this.filters.limit = 20;
        this.filters.page = this.esPage;
        if (this.esPage == 0) {
            this.noSessionsAvailable = false;
        }

        if (this.generalDataConfig.hasOwnProperty("defaultFilters")) {
            if (this.isLoggedIn) {
                this.filters.isPublished = true;
                this.filters.statusIds = ["0"];
                this.filters.attendeeTypeIds = [this.sharedService.loggedInAttendee.type.id];
            } else {
                if (this.generalDataConfig.defaultFilters.status.length > 0) {
                    if (!this.filters.hasOwnProperty("statusIds")) {
                        this.filters["statusIds"] = [];
                    }
                    this.generalDataConfig.defaultFilters.status.forEach((element) => {
                        if (this.filters.statusIds.indexOf(element.id) === -1) {
                            this.filters.statusIds.push(element.id);
                        }
                    });
                    if (this.filters.statusIds.indexOf("0") >= 0) {
                        this.filters.isPublished = true;
                    } else {
                        this.filters.isPublished = false;
                    }
                } else {
                    this.filters.isPublished = true;
                }

                if (this.generalDataConfig.defaultFilters.attendeeType.length > 0) {
                    if (!this.filters.hasOwnProperty("attendeeTypeIds")) {
                        this.filters["attendeeTypeIds"] = [];
                    }
                    this.generalDataConfig.defaultFilters.attendeeType.forEach((element) => {
                        if (this.filters.attendeeTypeIds.indexOf(element.id) === -1) {
                            this.filters.attendeeTypeIds.push(element.id);
                        }
                    });
                }
            }

            if (this.generalDataConfig.defaultFilters.track.length > 0) {
                if (!this.filters.hasOwnProperty("trackIds")) {
                    this.filters["trackIds"] = [];
                }
                if (this.filters["trackIds"].length == 0) {
                    this.generalDataConfig.defaultFilters.track.forEach((element) => {
                        if (this.filters.trackIds.indexOf(element.id) === -1) {
                            this.filters.trackIds.push(element.id);
                        }
                    });
                    if (!this.defaultFilters.hasOwnProperty("trackIds")) {
                        this.defaultFilters.trackIds = this.filters.trackIds;
                    }
                }
            }

            if (this.generalDataConfig.defaultFilters.tags && this.generalDataConfig.defaultFilters.tags.length > 0) {
                if (!this.filters.hasOwnProperty("tagIds")) {
                    this.filters["tagIds"] = [];
                }
                if (this.filters["tagIds"].length == 0) {
                    this.generalDataConfig.defaultFilters.tags.forEach((element) => {
                        if (this.filters.tagIds.indexOf(element.id) === -1) {
                            this.filters.tagIds.push(element.id);
                        }
                    });
                    if (!this.defaultFilters.hasOwnProperty("tagIds")) {
                        this.defaultFilters.tagIds = this.filters.tagIds;
                    }
                }
            }

            if (this.generalDataConfig.defaultFilters.type.length > 0) {
                if (!this.filters.hasOwnProperty("typeIds")) {
                    this.filters["typeIds"] = [];
                }
                if (this.filters["typeIds"].length == 0) {
                    this.generalDataConfig.defaultFilters.type.forEach((element) => {
                        if (this.filters.typeIds.indexOf(element.id) === -1) {
                            this.filters.typeIds.push(element.id);
                        }
                    });
                    if (!this.defaultFilters.hasOwnProperty("typeIds")) {
                        this.defaultFilters.typeIds = this.filters.typeIds;
                    }
                }
            }
            if (this.generalDataConfig.defaultFilters.hideFullSessions) {
                this.filters["hideFullSessions"] = true;
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedDates")) {
            if (this.filters.hasOwnProperty("startDates") && this.filters["startDates"].length > 0) {
            } else {
                this.filters["startDates"] = [];
                if(this.sharedService.tabChangedDate) {
                    this.filters.startDates.push(this.sharedService.tabChangedDate);
                } else {
                    if(this.filterConfig.selectTimezone == "browser_timezone") {
                        let dates = this.sharedService.filterSessionDateForBrowserTimezone;
                        dates.forEach((element) => {
                            this.filters.startDates.push(this.datePipe.transform(element.id, "yyyy-MM-dd"));
                        });
                        let temp = [];
                        this.filters.startDates.forEach(element => {
                            if(temp.findIndex(item => item === element) == -1) {
                                temp.push(element);
                            }
                        });
                        this.filters.startDates = temp;
                    } else {
                        this.filterConfig.selectedDates.forEach((element) => {
                            element = moment(element).tz(this.sharedService.event.timeZoneKey).format(this.sharedService.dateFormat);
                            this.filters.startDates.push(this.datePipe.transform(element, "yyyy-MM-dd"));
                        });
                    }
                }
            }
        } else if(this.filters.hasOwnProperty("startDates") && this.filters.startDates.length == 0 && this.sharedService.tabChangedDate) {
            this.filters.startDates.push(this.sharedService.tabChangedDate);
        } else if (this.filters.hasOwnProperty("startDates") && this.filters.startDates.length == 0) {
            delete this.filters.startDates;
        }

        if(this.filterConfig.selectTimezone == 'browser_timezone' && this.filters?.startDates?.length > 0) {
            this.filters.dateRange = [];
            this.filters.startDates.forEach(element => {
                //first convert date to selected timezone 
                let timeZone = this.sharedService.timezone || moment.tz.guess()
                let startDate = moment(new Date(element + ' 00:00:00')).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
                let endDate = moment(new Date(element + ' 23:59:00')).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
                this.filters.dateRange.push({
                    'from': moment(new Date(startDate)).tz(this.defaultTimeZoneKey).format('YYYY-MM-DD HH:mm:ss'),
                    'to': moment(new Date(endDate)).tz(this.defaultTimeZoneKey).format('YYYY-MM-DD HH:mm:ss')
                })
            })
            delete this.filters.startDates;
        } else if(this.scrolling && this.filterConfig.selectTimezone == 'browser_timezone' && this.filters?.dateRange?.length > 0){
            //to retain dateRange on scroll
            this.scrolling = false;
        } else {
            delete this.filters.dateRange;
        }
        this.sharedService.tabChangedDate = '';

        if (this.filterConfig.hasOwnProperty("selectedTimes")) {
            if (this.filters.hasOwnProperty("startTimes") && this.filters["startTimes"].length > 0) {
            } else {
                this.filters["startTimes"] = [];
                this.filterConfig.selectedTimes.forEach((element) => {
                    this.filters.startTimes.push(this.datePipe.transform("Tue Jan 22 2019 " + element, "HH:mm"));
                });
            }
        } else if (this.filters.hasOwnProperty("startTimes") && this.filters.startTimes.length == 0) {
            delete this.filters.startTimes;
        }

        if (this.filterConfig.hasOwnProperty("selectedTypes")) {
            if (this.filters.hasOwnProperty("typeIds") && this.filters["typeIds"].length > 0) {
            } else {
                this.filters["typeIds"] = [];
                this.filterConfig.selectedTypes.forEach((element) => {
                    this.filters.typeIds.push(element);
                });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedTracks")) {
            if (this.filters.hasOwnProperty("trackIds") && this.filters["trackIds"].length > 0) {
            } else {
                    this.filters["trackIds"] = [];
                    this.filterConfig.selectedTracks.forEach((element) => {
                        this.filters.trackIds.push(element);
                    });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedLocations")) {
            if (this.filters.hasOwnProperty("locationIds") && this.filters["locationIds"].length > 0) {
            } else {
                    this.filters["locationIds"] = [];
                    this.filterConfig.selectedLocations.forEach((element) => {
                        this.filters.locationIds.push(element);
                    });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedLevels")) {
            if (this.filters.hasOwnProperty("sessionLevelIds") && this.filters["sessionLevelIds"].length > 0) {
            } else {
                    this.filters["sessionLevelIds"] = [];
                    this.filterConfig.selectedLevels.forEach((element) => {
                        this.filters.sessionLevelIds.push(element);
                    });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedTags")) {
            if (this.filters.hasOwnProperty("tagIds") && this.filters["tagIds"].length > 0) {
            } else {
                    this.filters["tagIds"] = [];
                    this.filterConfig.selectedTags.forEach((element) => {
                        this.filters.tagIds.push(element);
                    });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedIndustries")) {
            if (this.filters.hasOwnProperty("industry") && this.filters["industry"].length > 0) {
            } else {
                    this.filters["industry"] = [];
                    this.filterConfig.selectedIndustries.forEach((element) => {
                        this.filters.industry.push(element);
                    });
            }
        }

        if (this.filterConfig.hasOwnProperty("selectedJobFunctions")) {
            if (this.filters.hasOwnProperty("jobFunction") && this.filters["jobFunction"].length > 0) {
            } else {
                    this.filters["jobFunction"] = [];
                    this.filterConfig.selectedJobFunctions.forEach((element) => {
                        this.filters.jobFunction.push(element);
                    })
            }
        }

        this.sharedService.sessionEnumCustomFields.forEach(element => {
                if(this.filterConfig.hasOwnProperty('selectedOptions') && Object.keys(this.filterConfig.selectedOptions).length > 0) {
                    if(this.filterConfig.selectedOptions.hasOwnProperty(['customField_' + element.id]) && ((this.filterConfig.selectedOptions['customField_' + element.id].length == element.options.length + 1) || this.filterConfig.selectedOptions['customField_' + element.id].length == 0)) {
                        delete this.filterConfig.selectedOptions['customField_' + element.id];
                    }
                }
            });

        if(this.filterConfig.hasOwnProperty('selectedOptions') && Object.keys(this.filterConfig.selectedOptions).length === 0) {
                delete this.filterConfig.selectedOptions;
        }

        if(this.filterConfig.hasOwnProperty("selectedOptions")) {
            if (this.filters.hasOwnProperty("customFieldOptions")) {
                for (let prop in this.filters.customFieldOptions) {
                    if (this.filters.customFieldOptions[prop].length == 0) {
                        const cfProp = "customField_" + prop;
                        if (this.filterConfig.selectedOptions.hasOwnProperty(cfProp) && this.filterConfig.selectedOptions[cfProp].length > 0) {
                            this.filters.customFieldOptions[prop] = this.filterConfig.selectedOptions[cfProp];
                        } else {
                            delete this.filters.customFieldOptions[prop];
                        }
                    }
                }
            } else {
                let cfFilter2 = {};
                for (let prop in this.filterConfig.selectedOptions) {
                    cfFilter2[prop.replace("customField_", "")] = this.filterConfig.selectedOptions[prop];
                }
                this.filters.customFieldOptions = cfFilter2;
            }
        }

        filter = this.filters;
        if (this.sessionFilter.query != null) {
            // filter["sessionName"] = this.sessionFilter.query;
        } else if (this.sessionFilter.startDate != null && this.sessionFilter.endDate != null) {
            filter["startDate"] = this.sessionFilter.startDate;
            filter["endDate"] = this.sessionFilter.endDate;
        }

        if(this.isLoggedIn == true && this.loginConfig.restrictedBrowsing == true) {
            filter['mySessions'] = true;
        }
        
        if(this.generalDataConfig.defaultFilters.hasOwnProperty('hidePastSessions') && this.generalDataConfig.defaultFilters.hidePastSessions == true) {
            filter['hidePastSession'] = true;
        }
        // for date range
 	 	if(this.sharedService.selectedDates) {
            filter['sessionStartDate'] = this.sharedService.selectedDates.startDate;
            filter['sessionEndDate'] = this.sharedService.selectedDates.endDate;
        } else {
            delete filter['sessionStartDate'];
            delete filter['sessionEndDate'];
        }
        
        this.attendeeSessionService.getSessions(filter).subscribe((resp) => {
            delete this.filters["deleteExcludedAndFetch"];
            this.generalDataConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
            );
            if (resp.body != null) {
                if (resp.body["sessions"].length == 0 && !this.filterResults) {
                    this.noSessionsInCatalog = true;
                } else if (resp.body["sessions"].length == 0 && this.filterResults) {
                    this.noSessionsAvailable = true;
                } else {
                     if(this.sharedService.excData.instanceId && this.sharedService.excData.instanceId.length>0) {
                       let tempid = this.sharedService.excData.instanceId
                        resp.body["sessions"] = resp.body["sessions"].filter(function(item){ 
                            return tempid.indexOf(item.id) == -1; 
                         });
                    }
                    
                    resp.body["sessions"].forEach((element) => {
                        element.showOtherInstances = false;
                        if(this.instanceCount && this.instanceCount.length > 0) {
                            let index = this.instanceCount.findIndex(object => {
                                return object.key.toLowerCase() == element.sessionCode.toLowerCase();
                            });
                            if(index >= 0) {
                                element.showOtherInstances = true;
                            }
                        }
                        
                        if(element.capacity > 0 && (element.remaining == null) && element.registered == null) {
                            element.remaining = element.capacity;
                        }

                        if(element.waitlistedLimit && element.waitlistedLimit > 0 && (element.waitlisted == null || element.waitlisted == 0)) {
                            element.remainingWaitlist = element.waitlistedLimit;
                        }

                        if(element.documents && element.documents.length>0) {
                            element.documents.sort(function(a, b) {
                                return parseInt(a.id) - parseInt(b.id);
                            });
                        }
                        element.event = this.sharedService.event;
                        element.registrations = this.sharedService.loggedInAttendee;
                        if(element.webinar && element.webinar != null && element.webinar.dialinNumbers != null) {
                            let temp = JSON.parse(element.webinar.dialinNumbers);
                            element.dialinNumbers = temp.dialinInfoHTML
                            element.dialinNumbers = element.dialinNumbers.replace(
                             new RegExp("href", "g"),
                             "(cclClick)='preventModal($event)' href"
                         );
                         }
                    })
                    this.sharedService.updateDateTime(resp.body["sessions"], this.filterConfig.selectTimezone, 'generalList');
                    if (this.esPage == 0) {
                        this.sharedService.totalCountOfGeneralSessions =
                            resp.body["sessions"].length + this.sharedService.excData.size;
                    } else {
                        this.sharedService.totalCountOfGeneralSessions =
                            this.sharedService.totalCountOfGeneralSessions + resp.body["sessions"].length;
                    }
                    this.esPage = this.esPage + 1;
                    this.sharedService.allSessionsHidden = false;
                }
                var idx = 0;
                this.sessionList = {
                    sessions: resp.body["sessions"],
                    idx: function() {
                        return idx++;
                    },
                    resetIndex: function() {
                        idx -= 1;
                        return;
                    },
                    index: function() {
                        return idx;
                    }
                };
                this.generalSessionConfig = JSON.parse(
                    this.sharedService.configs[this.sharedService.configTypes.SESSION.general].config
                );

                if(!this.generalSessionConfig.catalogConfig.hasOwnProperty('searchBarText')) {
                    this.generalSessionConfig.catalogConfig.searchBarText = 'Enter a Search term to find Sessions...'
                }

                if(!('instanceCheckValidation' in this.generalSessionConfig.catalogConfig)) {
                    this.generalSessionConfig.catalogConfig['instanceCheckValidation'] = false;
                }

                if(!('inventoryLock' in this.generalSessionConfig.catalogConfig)) {
                    this.generalSessionConfig.catalogConfig['inventoryLock'] = false;
                }

                if (this.isLoggedIn) {
                    this.buttonConfig = this.generalSessionConfig["catalogConfig"]["buttonConfig"];
                }
                if(this.generalList) {
                    this.tempgeneralList = this.generalList
                } else {
                    this.generalList = this.tempgeneralList
                }
                if (
                    this.generalDataConfig.topLevel.sortingBy != null &&
                    this.generalDataConfig.topLevel.sortingBy != ""
                ) {
                    this.groupingSession();
                } else {
                    if (this.generalList != null && this.clearGeneralSessionList) {
                        this.generalList.clear();
                        this.clearGeneralSessionList = false;
                    }
                    this.listemplateHelper(
                        this.generalSessionConfig,
                        this.generalList,
                        this.generalListRef,
                        "noGrouping-general",
                        ""
                    );
                }

                if (this.filters["speakerIds"] != null && this.filters["speakerIds"].length > 0) {
                    var speaker = this.ngxSmartModalService.getModalData("myModal")["speakerData"];
                    this.sharedService.filterData["speaker"] = [
                        {
                            id: speaker.id,
                            label: "Speaker Name: " + speaker.speakerFirstName + " " + speaker.speakerLastName
                        }
                    ];
                    this.sharedService.selectedFilterData["speaker"] = {
                        [speaker.id]: true
                    };
                    this.ngxSmartModalService.close("myModal");
                    this.sharedService.clearAllFilterEnabled = true;
                    this.sharedService.speakerFilterApplied = false;
                } else {
                    delete this.filters.speakerIds;
                    this.sharedService.speakerFilterApplied = false;
                    this.sharedService.filterData["speaker"] = [];
                    this.sharedService.selectedFilterData["speaker"] = {};
                }
            }
        });
        this.showCarousel = true;
    }

    openLoginPopup(item) {
        let url = "";
        if (item == "login") {
            this.popupService.setPosition("center");
            this.popupService.setSize("small");
            this.popupService.togglePopup();
            this.sharedService.currentPopup = {
                title: null,
                navLinks: null,
                saveMessage: "reg-login",
                showFooter: false
            };
            url = "popup/login";
        }
        this.sharedService.navigateToOutlet("popup", url);
    }

    previewAttendeeSide(list) {
        let resp = {};
        resp["body"] = list;
        if (!this.fromAttendee) {
            this.generalDataConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
            );
        }

        if (resp["body"] != null) {
            var idx = 0;
            this.sessionList = {
                sessions: resp["body"]["sessions"],
                idx: function() {
                    return idx++;
                },
                resetIndex: function() {
                    idx -= 1;
                    return;
                },
                index: function() {
                    return idx;
                }
            };
            if (!this.fromAttendee) {
                this.generalSessionConfig = JSON.parse(
                    this.sharedService.configs[this.sharedService.configTypes.SESSION.general].config
                );
            }

            if (this.generalDataConfig.topLevel.sortingBy != null && this.generalDataConfig.topLevel.sortingBy != "") {
                this.groupingSession();
            } else {
                if (this.generalList != null) {
                    this.generalList.clear();
                }
                this.listemplateHelper(
                    this.generalSessionConfig,
                    this.generalList,
                    this.generalListRef,
                    "noGrouping-general",
                    ""
                );
            }
        }
    }

    async ngOnInit() {
        var customTags = ["{@ddf.", "@}"];
        const htmlScriptElement = document.createElement('script');
 	 	htmlScriptElement.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
 	 	this.elementRef.nativeElement.appendChild(htmlScriptElement);
        this.mustache.tags = customTags;
        this.generalDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
        );
        if(this.sharedService.mysessions) {
            this.filters.fetchFavInstanceList = false;
            this.filters.mySessions = true;
        } else if(this.sharedService.myfav){
            this.filters.fetchFavInstanceList = true;
            this.filters.mySessions = false;
        } else {
            delete this.filters.fetchFavInstanceList;
            delete this.filters.mySessions;
        }


        this.instanceCount = [];
        try {
            let result = await this.getSessionInstanceCount();
            if(result["data"]) {
                this.instanceCount = JSON.parse(result["data"]);
            }
        } catch (error) {
            // catch error here
        }
        
        
        this.getHighlightedAndPromotedSessions();

        // If there is a selected Saved Filter, wait until all filters are loaded
        // Executed on subscription when message.text = 'pre-filter-loaded' two times
        if (!this.sharedService.filterName) {
            this.getLoggedInAttendee();
        } else if (this.sharedService.preSetfilter && this.isPreFilterLoaded == 2) {
            this.setPreFilters();
            this.getLoggedInAttendee();
        }
    }
    popupmodalData: any;
    openCardPopup(modalData, param) {
        this.ngxSmartModalService.setModalData(modalData, "sessionModal", true);
        this.ngxSmartModalService.open("sessionModal", false);
        this.popupmodalData = modalData;
        this.vc = param['vc'];
        this.createComponentFromRaw(param, this.popupmodalData.modalContent, this.mustache, this.popupmodalData.sessionList, this.vc, this.vcRef);
    }

    getSessionInstanceCount() {
        let data = {
            statusIds: ["6"],
            eventId: this.sharedService.event.id
        }
        return new Promise<any>((resolve, reject) => {
            this.attendeeSessionService.getInstanceCount(data).then(resp => {
                resolve(resp?.body);
            }).catch(error => {
                reject(error);
            })  
        })
    }

    setPreFilters () {
        this.filterResults = true;
            this.clearGeneralSessionList = true;
            this.noSessionsAvailable = false;
            this.esPage = 0;
            let cfFilter = {};
            for (let prop in this.sharedService.selectedFilterData) {
                let esProp = "";
                if (prop === "sessionDate") {
                    esProp = "startDates";
                } else if (prop === "track") {
                    esProp = "trackIds";
                } else if (prop === "sessionType") {
                    esProp = "typeIds";
                } else if (prop === "location") {
                    esProp = "locationIds";
                } else if (prop === "speaker") {
                    esProp = "speakerIds";
                } else if (prop === "sessionTime") {
                    esProp = "startTimes";
                } else if (prop === "tag") {
                    esProp = "tagIds";
                } else if (prop === "sessionLevel") {
                    esProp = "sessionLevelIds";
                } else if (prop.indexOf("customField_") > -1) {
                    esProp = "customFieldOptions";
                    cfFilter[prop] = [];
                } else {
                    esProp = prop;
                }
                this.filters[esProp] = [];
                let arr = [];
                
                for (let prop2 in this.sharedService.selectedFilterData[prop]) {
                    if (this.sharedService.selectedFilterData[prop][prop2] === true) {
                        this.sharedService.filterData[prop].forEach((element) => {
                            if (element.id + "" === prop2) {
                                if (prop === "sessionDate") {
                                    this.filters[esProp].push(this.datePipe.transform(element.id, "yyyy-MM-dd"));
                                } else if (prop.indexOf("customField_") > -1) {
                                    cfFilter[prop].push(element.id);
                                } else if (prop === "sessionTime") {  
                                    if(this.filterConfig.selectTimezone == 'event_timezone' || this.sharedService.timezone == this.sharedService.event.timeZoneKey) {
                                        this.filters[esProp].push(this.convertTime12to24(prop2))
                                    } else {
                                        let pstStartTime = moment(new Date()).tz(this.sharedService.timezone).format();
                                        let temps = pstStartTime.split("T");
                                        let dateSTr = temps[0] + 'T' + this.convertTime12to24(prop2) + temps[1].substr(5);
                                        let time = moment(dateSTr).tz(this.defaultTimeZoneKey).format('hh:mm A');
                                        this.filters[esProp].push(
                                            this.datePipe.transform("Tue Jan 22 2019 " + time, "HH:mm")
                                        );
                                    }
                                } else {
                                    this.filters[esProp].push(element.id);
                                }
                            }
                        });
                    }
                }
            }
            let cfFilter2 = {};
            for (let prop in cfFilter) {
                cfFilter2[prop.replace("customField_", "")] = cfFilter[prop];
            }
            this.filters.customFieldOptions = cfFilter2;
    }

    getSessionRegisteredLabel(param, sessionConfig, type) {
        let padding = sessionConfig.regionConfig.padding;
        let top = "-10px";
        let right = "-10px";
        if (padding != null) {
            let paddings = padding.split(" ");
            if (paddings.length == 1) {
                top = "-" + paddings[0];
                right = "-" + paddings[0];
            } else if (paddings.length == 2 || paddings.length == 4) {
                top = "-" + paddings[0];
                right = "-" + paddings[1];
            }
        }
        let temp = "";
        if(type == 'list' || !type) {
            temp =
            '<span *ngIf="isEnrolled[{@ddf.index@}]"><div ' +
            `[ngClass]="{'general-session-catalog-header-region-label': true, ` +
            `'general-session-catalog-header-region-background-1-4': +registrationSessionStatusId[{@ddf.index@}] == 1 || +registrationSessionStatusId[{@ddf.index@}] == 4,` +
            `'general-session-catalog-header-region-background-2-3': !(+registrationSessionStatusId[{@ddf.index@}] == 1 || +registrationSessionStatusId[{@ddf.index@}] == 4)}">` +
            "<span class='label-align' *ngIf='registrationSessionStatusId[{@ddf.index@}] == 1'>" +
            param["buttonConfig"].regLabel +
            "</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 2'>Cancelled</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 3'>No Show</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 4'>Attended</span></div></span>";
        } else if(type=='card') {
            temp = '<span *ngIf="isEnrolled[{@ddf.index@}]"><div ' +
            `[ngClass]="{'general-session-catalog-header-region-label card-label-align': true, ` +
            `'general-session-catalog-header-region-background-1-4': +registrationSessionStatusId[{@ddf.index@}] == 1 || +registrationSessionStatusId[{@ddf.index@}] == 4,` +
            `'general-session-catalog-header-region-background-2-3': !(+registrationSessionStatusId[{@ddf.index@}] == 1 || +registrationSessionStatusId[{@ddf.index@}] == 4)}">` +
            "<span class='label-align' *ngIf='registrationSessionStatusId[{@ddf.index@}] == 1'>" +
            param["buttonConfig"].regLabel +
            "</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 2'>Cancelled</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 3'>No Show</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 4'>Attended</span></div></span>";
        }
        
        return temp;
    }

    getSessionWaitlistedLabel(param, sessionConfig, type) {
        let padding = sessionConfig.regionConfig.padding;
        let top = "-10px";
        let right = "-10px";
        if (padding != null) {
            let paddings = padding.split(" ");
            if (paddings.length == 1) {
                top = "-" + paddings[0];
                right = "-" + paddings[0];
            } else if (paddings.length == 2 || paddings.length == 4) {
                top = "-" + paddings[0];
                right = "-" + paddings[1];
            }
        }
        let temp
        if(type == 'card') {
            temp =
            '<span *ngIf="isWaitListed[{@ddf.index@}]"><div ' +
            'class="general-session-catalog-button-wait-card label-align">' +
            param["buttonConfig"].waitLabel +
            "</div></span>";
            
        } else {
            temp =
            '<span *ngIf="isWaitListed[{@ddf.index@}]"><div ' +
            'class="general-session-catalog-button-wait">' +
            param["buttonConfig"].waitLabel +
            "</div></span>";
        }

        
        return temp;
    }

    listemplateHelper(sessionConfig, list, listRef, type, displayAs) {
        let param: any = {};
        let loggedInUser = sessionStorage.getItem("loggedInAttendee_" + this.sharedService.eventUUID);
        if((loggedInUser != "null" && loggedInUser)  && sessionConfig.catalogConfig.header.textConfig.privateTemplate) {
            param["headerTemplate"] = this.getSafeHtmlDescStr(sessionConfig.catalogConfig.header.textConfig.privateTemplate, type);
        } else {
            param["headerTemplate"] = this.getSafeHtmlDescStr(sessionConfig.catalogConfig.header.textConfig.template, type);
        }
        let templateStr = ''
        if((loggedInUser != "null" && loggedInUser) && sessionConfig.catalogConfig.body.textConfig.privateTemplate) {
            templateStr = sessionConfig.catalogConfig.body.textConfig.privateTemplate;
        } else {
            templateStr = sessionConfig.catalogConfig.body.textConfig.template;
        }
        if (sessionConfig.catalogConfig.body.hasOwnProperty('assetConfig') && sessionConfig.catalogConfig.body.assetConfig.enableFirstGroup && sessionConfig.catalogConfig.body.assetConfig.firstGroupList.length>0) {
            templateStr = templateStr + sessionConfig.catalogConfig.body.assetConfig.documentTemplate;
        }

        if (sessionConfig.catalogConfig.body.hasOwnProperty('assetConfig') && sessionConfig.catalogConfig.body.assetConfig.enableSecondGroup && sessionConfig.catalogConfig.body.assetConfig.secondGroupList.length>0) {
            templateStr = templateStr + sessionConfig.catalogConfig.body.assetConfig.videoTemplate;
        }

        if (sessionConfig.catalogConfig.body.hasOwnProperty('assetConfig') && sessionConfig.catalogConfig.body.assetConfig.enableThirdGroup && sessionConfig.catalogConfig.body.assetConfig.thirdGroupList.length>0) {
            templateStr = templateStr + sessionConfig.catalogConfig.body.assetConfig.thirdTemplate;
        }
        param["bodyTemplate"] = this.getSafeHtmlDescStr(templateStr, type);

        param["headerTemplate"] = this.customFieldFileDownloadHelper(param["headerTemplate"], type);

        param["bodyTemplate"] = this.customFieldFileDownloadHelper(param["bodyTemplate"], type);

        param["sessionModalHeader"] =
            "<div class='session-header-label'>" + sessionConfig.labelConfig.label + "</div>";

        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.customFieldMap.", "g"),
            "{@ddf.&customFieldMap."
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.customFieldMap.", "g"),
            "{@ddf.&customFieldMap."
        );
        
        if (type === "highlighted") {
            param["class"] = "highlighted-session";
        } else if (type === "promoted") {
            param["class"] = "promoted-session";
        } else {
            param["class"] = "general-session";
        }

        param["headerStyleStr"] = this.createStyleString(sessionConfig.catalogConfig.header);

        param["headerTextStyleStr"] = this.createTextStyle(
            sessionConfig.catalogConfig.header,
            sessionConfig.catalogConfig.header.imageConfig.width,
            sessionConfig.layout
        );

        param["bodyStyleStr"] = this.createStyleString(sessionConfig.catalogConfig.body);

        param["bodyTextStyleStr"] = this.createTextStyle(
            sessionConfig.catalogConfig.body,
            sessionConfig.catalogConfig.body.imageConfig.width,
            sessionConfig.layout
        );

        param["headerImgStyle"] = this.createImageStyle(sessionConfig.catalogConfig.header, sessionConfig.layout);

        param["bodyImgStyle"] = this.createImageStyle(sessionConfig.catalogConfig.body, sessionConfig.layout);

        param["headerImgBasedOn"] = sessionConfig.catalogConfig.header.imageConfig.basedOn;

        param["bodyImgBasedOn"] = sessionConfig.catalogConfig.body.imageConfig.basedOn;

        param["layout"] = sessionConfig.layout;

        param["type"] = type + "-";

        param["modalService"] = this.ngxSmartModalService;

        param["attendeeSessionService"] = this.attendeeSessionService;
        param["catalogService"] = this.catalogService;

        param["speakerStyleStr"] = this.createStyleString(this.speakerConfig.catalogConfig.body);

        param["speakerImgStyle"] = this.createImageStyle(
            this.speakerConfig.catalogConfig.body,
            this.speakerConfig.layout
        );

        param["speakerImgBasedOn"] = this.speakerConfig.catalogConfig.body.imageConfig.basedOn;

        param["speakerTextStyleStr"] = this.createTextStyle(
            this.speakerConfig.catalogConfig.body,
            this.speakerConfig.catalogConfig.body.imageConfig.width,
            this.speakerConfig.layout
        );

        param["speakerTemplate"] = this.speakerConfig.catalogConfig.body.textConfig.template;
        param["speakerTemplate"] = this.customFieldFileSpeakerDownloadHelper(param["speakerTemplate"]);

        param["speakerLayout"] = this.speakerConfig.layout;

        param["speakerTemplate"] = param["speakerTemplate"].replace(
            "{@ddf.sessionList@}",
            "<span id='speakerSession' class='cursor-pointer'>View Sessions of this Speaker</span>"
        );

        param["speakerTemplate"] = param["speakerTemplate"].replace(
            new RegExp("{@ddf.biography@}", "g"),
            "{@ddf.&biography@}"
        );

        param["speakerTemplate"] = param["speakerTemplate"].replace(
            new RegExp("{@ddf.customFieldMap.", "g"),
            "{@ddf.&customFieldMap."
        );

        param["speakerTemplate"] = param["speakerTemplate"]
            .replace(new RegExp('contenteditable="true"', "g"), "")
            .replace(new RegExp("contenteditable='true'", "g"), ""); //to remove editable

        param["speakerModalHeader"] =
            "<div class='speaker-header-label'>" + this.speakerConfig.labelConfig.label + "</div>";

        this.viewSpeakerSessionList = true;
            param['defaultHeaderThumbnailURL'] = ''
            param['defaultBodyThumbnailURL'] = ''
            param['headerbannerImageType'] = ''
            param["bodybannerImageType"]  = ''
            param["headerPlayIconTemplate"] = ''
            param["bodyPlayIconTemplate"] = ''

        if (sessionConfig.layout === "l_banner" && sessionConfig.catalogConfig.header.imageConfig.basedOn === "dynamic_img") {
            param["headerBanner"] = sessionConfig.catalogConfig.header.imageConfig.banner;
        }

        if (sessionConfig.layout === "l_banner" && sessionConfig.catalogConfig.body.imageConfig.basedOn === "dynamic_img") {
            param["bodyBanner"] = sessionConfig.catalogConfig.body.imageConfig.banner;
        }

        

        if (sessionConfig.layout === "l_banner" && sessionConfig.catalogConfig.header.imageConfig.basedOn === "thumbnail_img") {
            param['defaultHeaderThumbnailURL'] = sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL
            param["headerbannerImageType"] = "thumbnail_img"
            param["headerPlayIconTemplate"] = sessionConfig.catalogConfig.header.imageConfig.displayIcon || ""
        }

        if (sessionConfig.layout === "l_banner" && sessionConfig.catalogConfig.body.imageConfig.basedOn === "thumbnail_img") {
            param['defaultBodyThumbnailURL'] = sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL
            param["bodybannerImageType"] = "thumbnail_img"
            param["bodyPlayIconTemplate"] = sessionConfig.catalogConfig.body.imageConfig.displayIcon || ""
        }

        if (sessionConfig.catalogConfig.header.imageConfig.basedOn === "dynamic_img") {
            param["headerDynamicImg"] = sessionConfig.catalogConfig.header.imageConfig.dynamicImage;
        }


        if (sessionConfig.catalogConfig.body.imageConfig.basedOn === "dynamic_img") {
            param["bodyDynamicImg"] = sessionConfig.catalogConfig.body.imageConfig.dynamicImage;
        }

        if (this.speakerConfig.layout === "l_banner") {
            param["speakerBanner"] = this.speakerConfig.catalogConfig.body.imageConfig.banner;
        }


        if (this.speakerConfig.catalogConfig.body.imageConfig.basedOn === "dynamic_img") {
            param["speakerDynamicImg"] = this.speakerConfig.catalogConfig.body.imageConfig.dynamicImage;
        }

        

        

        //for speaker list
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.speakerList@}", "g"),
            '<span class="speakerContainer">{@ddf.#speakers@}<span class="speakerItem">{@ddf.speakerFirstName@} {@ddf.speakerLastName@}</span>{@ddf./speakers@}</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.speakerList@}", "g"),
            '<span class="speakerContainer">{@ddf.#speakers@}<span class="speakerItem">{@ddf.speakerFirstName@} {@ddf.speakerLastName@}</span>{@ddf./speakers@}</span>'
        );

        //For speaker popup
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.speakerFirstName@}",
            "<span (cclClick)=\"openModel($event,'{@ddf.userName@}', '" +
                this.sharedService.eventUUID +
                "' ,{@ddf.index@})\" title='View Speaker'>{@ddf.speakerFirstName@} </span>"
        );


        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.speakerFirstName@}",
            "<span (cclClick)=\"openModel($event,'{@ddf.userName@}', '" +
                this.sharedService.eventUUID +
                "' ,{@ddf.index@})\" title='View Speaker'>{@ddf.speakerFirstName@} </span>"
        );
        

        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.speakerLastName@}",
            "<span (cclClick)=\"openModel($event,'{@ddf.userName@}', '" +
                this.sharedService.eventUUID +
                "' ,{@ddf.index@})\" title='View Speaker'>{@ddf.speakerLastName@}</span>"
        );

 
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.speakerLastName@}",
            "<span (cclClick)=\"openModel($event,'{@ddf.userName@}', '" +
                this.sharedService.eventUUID +
                "' ,{@ddf.index@})\" title='View Speaker'>{@ddf.speakerLastName@}</span>"
        );


        //For abstract file download
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.abstractFile@}",
            '<span>{@ddf.#documents@}<span title="Download Abstract" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Abstract\'">{@ddf.name@} </span>{@ddf./documents@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.abstractFile@}",
            '<span>{@ddf.#documents@}<span title="Download Abstract" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Abstract\'">{@ddf.name@} </span>{@ddf./documents@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{*ddf.abstractFile*}",
            '{@ddf.#documents@}<li *ngIf="\'{@ddf.type@}\' === \'Abstract\' && \'{@ddf.name@}\'" class="' + type + '-session-asset-row"><span class="' + type + '-session-document-label pull-left"> {@ddf.name@} </span> <span class="pull-right"> <button class="' + type + '-session-download-btn" title="Download" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\'>Download</button></span></li>{@ddf./documents@}'
        );

        //For presentation files download
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.presentations@}",
            '<br><span>{@ddf.#documents@}<span title="Download Session Document" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Non-Abstract\'">{@ddf.name@}<br></span>{@ddf./documents@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.presentations@}",
            '<br><span>{@ddf.#documents@}<span title="Download Session Document" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Non-Abstract\'">{@ddf.name@}<br></span>{@ddf./documents@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{*ddf.presentations*}",
            '{@ddf.#documents@}<li *ngIf="\'{@ddf.type@}\' === \'Non-Abstract\' && \'{@ddf.name@}\'" class="' + type + '-session-asset-row"><span class="' + type + '-session-document-label pull-left"> {@ddf.name@} </span> <span class="pull-right"> <button class="' + type + '-session-download-btn" title="Download" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\'>Download</button></span></li>{@ddf./documents@}'
        );

        //For showing other instances
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.allInstances@}",
            '<span *ngIf=\'checkInstances("{@ddf.statusId@}", "{@ddf.showOtherInstances@}")\' title="Show Other Times" (cclClick)=\'showAllInstances($event,"{@ddf.sessionId@}", "{@ddf.id@}")\'>Show other schedules</span>'
        );
        
       
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.allInstances@}",
            `<span style="cursor: pointer;" *ngIf=\'checkInstances("{@ddf.statusId@}", "{@ddf.showOtherInstances@}")\' title="Show Other Times" (cclClick)=\'showAllInstances($event,"{@ddf.sessionId@}", "{@ddf.id@}")\'>Show other schedules</span>`
        );
        
        //For Displaying Session fees with currency symbol
        param["headerTemplate"] = param["headerTemplate"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');
        param["headerTemplate"] = param["headerTemplate"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        param["bodyTemplate"] = param["bodyTemplate"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');
        param["bodyTemplate"] = param["bodyTemplate"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        //for tags array
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );

        // Replace Session Industries and JobFunctions DDF values
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );

        param["attendeeSessionService"] = this.attendeeSessionService;
        param["datePipe"] = this.datePipe;

        param["notifyService"] = this.notifyService;

        param["_flashMessagesService"] = this._flashMessagesService;

        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.event.strStartDate@}","g"),
            "{{'{@ddf.event.strStartDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.event.strEndDate@}","g"),
            "{{'{@ddf.event.strEndDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );


        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.event.strStartDate@}","g"),
            "{{'{@ddf.event.strStartDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.event.strEndDate@}","g"),
            "{{'{@ddf.event.strEndDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );

        //For session date formatting
        if (displayAs != "1_carousel") {
            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.startTime@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                    this.generalDataConfig.dateTimeFormats.dateFormat +
                    "," +
                    this.generalDataConfig.dateTimeFormats.timeFormat +
                    "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.startDate@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.startTimeHHmm@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.startDateTime@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                    this.generalDataConfig.dateTimeFormats.dateFormat +
                    "," +
                    this.generalDataConfig.dateTimeFormats.timeFormat +
                    "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.endTime@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.endTimeHHmm@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.endDateTime@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" +
                    this.generalDataConfig.dateTimeFormats.dateFormat +
                    "," +
                    this.generalDataConfig.dateTimeFormats.timeFormat +
                    "'}}"
            );

            param["headerTemplate"] = param["headerTemplate"].replace(
                new RegExp("{@ddf.endDate@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
            );


                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.startTime@}","g"),
                        "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                            this.generalDataConfig.dateTimeFormats.dateFormat +
                            "," +
                            this.generalDataConfig.dateTimeFormats.timeFormat +
                            "'}}"
                    ); 

                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.startDate@}","g"),
                        "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.startTimeHHmm@}","g"),
                        "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.startDateTime@}","g"),
                        "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                            this.generalDataConfig.dateTimeFormats.dateFormat +
                            "," +
                            this.generalDataConfig.dateTimeFormats.timeFormat +
                            "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.endTime@}","g"),
                        "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.endTimeHHmm@}","g"),
                        "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.endDateTime@}","g"),
                        "{{'{@ddf.endTime@}'|toDateObj| date: '" +
                            this.generalDataConfig.dateTimeFormats.dateFormat +
                            "," +
                            this.generalDataConfig.dateTimeFormats.timeFormat +
                            "'}}"
                    );
        
                    param["bodyTemplate"] = param["bodyTemplate"].replace(
                        new RegExp("{@ddf.endDate@}","g"),
                        "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
                    );
        
                }
        
        param["filterConfig"] = this.filterConfig;        
        param["isLoggedIn"] = this.isLoggedIn;
        param["sharedService"] = this.sharedService;
        param["popupService"] = this.popupService;
        param["route"] = this.route;
        param["navSecondaryService"] = this.navSecondaryService;
        param["compiler"] = this.compiler;
        param["moduleRef"] = this.moduleRef;
        param["cookieService"] = this.cookieService;
        param["injector"] = this.injector;
        param["router"] = this.router;
        param["messageService"] = this.messageService;
        param['vc'] = this.vc;
        param['loginConfig'] = this.loginConfig;
        param['loadScript'] = this.loadScript;
        param['localTimezoneKey'] = this.localTimezoneKey;
        param['speakerConfig'] = this.speakerConfig;
        param['generalSessionConfig'] = this.generalSessionConfig;
        param['generalDataConfig'] = this.generalDataConfig;
        param['clientKey'] = this.clientKey;
        this.popUpParam = param;
        this.styleType = type;
        if (type === "general") {
            if (this.isLoggedIn) {
                
                param["buttonConfig"] = sessionConfig.catalogConfig.buttonConfig;
                if (param["buttonConfig"] != undefined) {
                    if (param["buttonConfig"].regLabel == undefined || param["buttonConfig"].regLabel == "") {
                        param["buttonConfig"].regLabel = "Registered";
                    }
                    if (param["buttonConfig"].waitLabel == undefined || param["buttonConfig"].waitLabel == "") {
                        param["buttonConfig"]["waitLabel"] = "Waitlisted";
                    }
                    if (
                        param["buttonConfig"].cartButtonLabel == undefined ||
                        param["buttonConfig"].cartButtonLabel == ""
                    ) {
                        param["buttonConfig"]["cartButtonLabel"] = "Add to cart";
                    }
                    if (
                        param["buttonConfig"].fillingFastLabel == undefined ||
                        param["buttonConfig"].fillingFastLabel == ""
                    ) {
                        param["buttonConfig"]["fillingFastLabel"] = "Filling Fast";
                    }
                    if (
                        param["buttonConfig"].fillingFastPercent == undefined ||
                        param["buttonConfig"].fillingFastPercent == ""
                    ) {
                        param["buttonConfig"]["fillingFastPercent"] = "10";
                    }
                    if (!param["buttonConfig"].hasOwnProperty("enableAddToCartButton")) {
                        param["buttonConfig"]["enableAddToCartButton"] = true;
                    }
                    if (
                        param["buttonConfig"].capacityFullLabel == undefined ||
                        param["buttonConfig"].capacityFullLabel == ""
                    ) {
                        param["buttonConfig"]["capacityFullLabel"] = "Session capacity is full";
                    }

                    if (!param["buttonConfig"].removeScheduleButtonLabel) {
                        param["buttonConfig"].removeScheduleButtonLabel = "Cancel";
                    }
                    if (!param["buttonConfig"].removeScheduleButtonBackground) {
                        param["buttonConfig"].removeScheduleButtonBackground = "#ffffff";
                    }
                    if (!param["buttonConfig"].removeScheduleButtonColor) {
                        param["buttonConfig"].removeScheduleButtonColor = "#000000";
                    }
                    if (!param["buttonConfig"].removeScheduleButtonStyle) {
                        param["buttonConfig"].removeScheduleButtonStyle = "bold";
                    }
                }
                // for footer on header
                let hideClass = 'session-header-icon-right-secondary';
                let hideHeaderClass = 'session-header-icon-right-card-secondary';
                if(!param["buttonConfig"].favIconSec || !param["buttonConfig"].favIcon) {
                    hideClass = 'session-header-icon-right';
                    hideHeaderClass = 'session-header-icon-right-card';
                }
                let add_to_schedule = `{{ 'cart_section.add_to_schedule' | translate }}`
                if(this.sharedService.catalogLayoutConfig.generalStyle == "list" || !this.sharedService.catalogLayoutConfig.generalStyle) {
                    param["headerTemplate"] =
                    param["headerTemplate"] +
                    '<div *ngIf="{@ddf.break@}" class="row"><div *ngIf=\'showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}] && !isViewOnly[{@ddf.index@}]\'><div class="session-header-icon-right" *ngIf=\'addToFavourite[{@ddf.index@}]\'><i title="Add Session to Favorites" (cclClick)=\'addSessionToFavourite($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].favIconSec +
                    ' general-session-catalog-button-fav-icon pull-right"></i></div><div class=' +  hideClass + ' *ngIf=\'addToFavourite[{@ddf.index@}]\'><i title="Hide Session" (cclClick)=\'excludeSession($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].excIcon +
                    ' general-session-catalog-button-exclude-icon pull-right"></i></div><div class="session-header-icon-right" *ngIf=\'!addToFavourite[{@ddf.index@}]\'><i title="Remove Session from Favorites" (cclClick)=\'removeSessionFromFavourite($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].favIcon +
                    ' general-session-catalog-button-fav-icon pull-right"></i></div></div><div class="session-header-icon-right pr-0" *ngIf="!showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    ' && !isWaitListed[{@ddf.index@}] && !isViewOnly[{@ddf.index@}];else flags" class="col-12 session-header-icon-right pr-0"><i title="In Cart"' +
                    ' class="fa ' +
                    param["buttonConfig"].cartIcon +
                    ' general-session-catalog-button-cart-icon pull-right"></i></div><ng-template #flags><div class="col-12 session-header-icon-right pr-0" (cclClick)=\'labelClick($event)\'>' +
                    this.getSessionRegisteredLabel(param, sessionConfig.catalogConfig.header, this.sharedService.catalogLayoutConfig.generalStyle) +
                    this.getSessionWaitlistedLabel(param, sessionConfig.catalogConfig.header,this.sharedService.catalogLayoutConfig.generalStyle) +
                    "</div></ng-template></div>";
                } else {
                    param["headerTemplate"] =
                    param["headerTemplate"] +
                    '<div *ngIf="{@ddf.break@}" class="row footer-header-container"><div *ngIf=\'showAddToCart[{@ddf.index@}] && showButton[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    '\'><div *ngIf="!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]" title="Add to Cart" (cclClick)=\'addSessionToCart($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}],"{@ddf.sessionId@}")\'><div class="session-header-icon-left-card"' +
                    "><span> " +
                    param["buttonConfig"].cartButtonLabel +
                    "</span></div></div></div>" +
                    '<div *ngIf=\'(' +
                    !param["buttonConfig"].enableAddToCartButton +
                    ' && showButton[{@ddf.index@}]) || registrationSessionStatusId[{@ddf.index@}] == 2\'><div *ngIf="((!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]) || registrationSessionStatusId[{@ddf.index@}] == 2) && !isViewOnly[{@ddf.index@}]" title="Add to Schedule" (cclClick)=\'registerSession($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}], "{@ddf.startTime@}", "{@ddf.endTime@}", "{@ddf.sessionId@}")\'><div class="session-header-icon-left-card"' +                    '><span *ngIf="!isNotProcessingSession[{@ddf.index@}]">&nbsp;</span><span *ngIf=\'!isGoingToBeWaitlisted[{@ddf.index@}];else waitlist\'> <i class="fa fa-calendar-plus-o icon-size" aria-hidden="true"></i>' + add_to_schedule + '</span><ng-template #waitlist><span>Add to Waitlist</span></ng-template></div></div></div><div *ngIf=\'(isEnrolled[{@ddf.index@}] || isWaitListed[{@ddf.index@}]) && registrationSessionStatusId[{@ddf.index@}] != 2 && registrationSessionStatusId[{@ddf.index@}] != 4\'><div  title="Remove from Schedule" *ngIf=\'checkRestricted("{@ddf.isPrivate@}")\' (cclClick)=\'removeFromSchedule($event,"{@ddf.id@}",{@ddf.index@})\'><div class="general-session-remove-label-card general-session-catalog-remove-schedule-btn"' +
                    '><span *ngIf="!isNotProcessingSession[{@ddf.index@}]">&nbsp;</span><span>' +
                    param["buttonConfig"].removeScheduleButtonLabel +
                    '</span></div></div></div>' +
                    '<div *ngIf=\'showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]\'><div class="session-header-icon-right-card" *ngIf=\'addToFavourite[{@ddf.index@}]\'><i  title="Add to Favorites" (cclClick)=\'addSessionToFavourite($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].favIconSec +
                    ' general-session-catalog-button-fav-icon pull-right"></i></div><div class=' + hideHeaderClass + ' *ngIf=\'addToFavourite[{@ddf.index@}]\'><i title="Hide Session" (cclClick)=\'excludeSession($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].excIcon +
                    ' general-session-catalog-button-exclude-icon pull-right"></i></div><div class="session-header-icon-right-card" *ngIf=\'!addToFavourite[{@ddf.index@}]\'><i title="Remove from Favorites" (cclClick)=\'removeSessionFromFavourite($event,{@ddf.index@},"{@ddf.id@}")\'' +
                    ' class="fa ' +
                    param["buttonConfig"].favIcon +
                    ' general-session-catalog-button-fav-icon pull-right"></i></div></div><div class="session-header-icon-right-card pr-0" *ngIf="!showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    ' && !isWaitListed[{@ddf.index@}];else flags" class="col-12 session-header-icon-right-card pr-0"><i' +
                    ' class="fa ' +
                    param["buttonConfig"].cartIcon +
                    ' general-session-catalog-button-cart-icon pull-right"></i></div><ng-template #flags><div class="session-header-label-right-bottom" (cclClick)=\'labelClick($event)\'>' +
                    this.getSessionRegisteredLabel(param, sessionConfig.catalogConfig.header, this.sharedService.catalogLayoutConfig.generalStyle) +
                    this.getSessionWaitlistedLabel(param, sessionConfig.catalogConfig.header,this.sharedService.catalogLayoutConfig.generalStyle) +
                    "</div></ng-template></div>";
                }

                if(!this.generalSessionConfig.catalogConfig.calendar) {
                    this.generalSessionConfig.catalogConfig.calendar = {
                    textConfig: this.sharedService.addEventtoCalendarConfig
                    }
                }
                
                if(!param["buttonConfig"].hasOwnProperty('enableAddToCalendarButton')) {
                    param["buttonConfig"].enableAddToCalendarButton = true
                }

 	            if(!param["buttonConfig"].hasOwnProperty('calendarButtonLabel')) {
 	                param["buttonConfig"].calendarButtonLabel = 'Add to Calendar';
                 }
                 
                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.startDateTime@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                    this.generalDataConfig.dateTimeFormats.dateFormat +
                    "," +
                    this.generalDataConfig.dateTimeFormats.timeFormat +
                    "'}}"
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.endDateTime@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" +
                    this.generalDataConfig.dateTimeFormats.dateFormat +
                    "," +
                    this.generalDataConfig.dateTimeFormats.timeFormat +
                    "'}}"
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.startDate@}","g"),
                    "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"    
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.endDate@}","g"),
                    "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"    
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.startTimeHHmm@}","g"),
                "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"    
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.endTimeHHmm@}","g"),
                "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}" 
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.speakerList@}", "g"),
                    '<span class="speakerContainer">{@ddf.#speakers@}<span class="speakerItem">{@ddf.speakerFirstName@} {@ddf.speakerLastName@}</span>{@ddf./speakers@}</span>'
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.tags@}", "g"),
                    '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
                );


                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{\\*ddf.regWebinar.participantJoinUrl\\*}", "g"),
                    "{@ddf.regWebinar.participantJoinUrl@}"
                );

                this.generalSessionConfig.catalogConfig.calendar.textConfig.template = this.generalSessionConfig.catalogConfig.calendar.textConfig.template.replace(
                    new RegExp("{@ddf.webinar.webinarThumbnail@}", "g"),
                    window.location.protocol + "//" + window.location.host + "{@ddf.webinar.webinarThumbnail@}"
                );
                
                if(this.sharedService.catalogLayoutConfig.generalStyle == "list" || !this.sharedService.catalogLayoutConfig.generalStyle) {
                // for footer on body
                param["bodyTemplate"] =
                    param["bodyTemplate"] +
                    '<div *ngIf="{@ddf.break@}" class="row footer-body-container"><hr class="footer-body-hr"><div *ngIf="false"><div class="col-sm-2 footer-body-currently-registered">Currently Registered</div><div class="col-sm-1 footer-body-registered">{@ddf.registered@}</div><div class="col-sm-1 footer-body-open">Open</div><div class="col-sm-2 footer-body-remaining">{@ddf.remaining@}</div></div><div *ngIf="!isEnrolled[{@ddf.index@}]" class="col-sm-6 footer-body-remaining-perc"' +
                    '>{@ddf.#remainingPercentage@}{@ddf.break@}{"capacity":"{@ddf.capacity@}","remaining":"{@ddf.remaining@}"}{@ddf./remainingPercentage@}</div><div class="col-sm-12 col--builder" *ngIf=\'(' +
                    !param["buttonConfig"].enableAddToCartButton +
                    ' && showButton[{@ddf.index@}]) || registrationSessionStatusId[{@ddf.index@}] == 2\'><div *ngIf="((!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]) || registrationSessionStatusId[{@ddf.index@}] == 2) && !isViewOnly[{@ddf.index@}]" title="Add to Schedule" (cclClick)=\'registerSession($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}], "{@ddf.startTime@}", "{@ddf.endTime@}", "{@ddf.sessionId@}")\'><div class="general-session-catalog-add-schedule-btn"' +
                    '><i title="Processing" class="fa fa-spinner fa-spin" *ngIf="!isNotProcessingSession[{@ddf.index@}]"></i><span *ngIf="!isNotProcessingSession[{@ddf.index@}]">&nbsp;</span><span *ngIf=\'!isGoingToBeWaitlisted[{@ddf.index@}];else waitlist\'>' + add_to_schedule + '</span><ng-template #waitlist><span>Add to Waitlist</span></ng-template></div></div></div><div class="col-sm-12 col--builder"><div title="Remove from Schedule" *ngIf=\'(isEnrolled[{@ddf.index@}] || isWaitListed[{@ddf.index@}]) && registrationSessionStatusId[{@ddf.index@}] != 2 && registrationSessionStatusId[{@ddf.index@}] != 4 && checkRestricted("{@ddf.isPrivate@}")\' (cclClick)=\'removeFromSchedule($event,"{@ddf.id@}",{@ddf.index@})\'><div class="general-session-catalog-remove-schedule-btn"' +
                    '><i title="Processing" class="fa fa-spinner fa-spin" *ngIf="!isNotProcessingSession[{@ddf.index@}]"></i><span *ngIf="!isNotProcessingSession[{@ddf.index@}]">&nbsp;</span><span>' +
                    param["buttonConfig"].removeScheduleButtonLabel +
                    '</span></div>' +
                    '</div>' +
                    '<div *ngIf="isEnrolled[{@ddf.index@}] && (registrationSessionStatusId[{@ddf.index@}] == 1 || registrationSessionStatusId[{@ddf.index@}] == 4) && ' +
                    param["buttonConfig"].enableAddToCalendarButton +
                    '" title="Add to Calendar" (cclClick)="labelClick($event)">' +
                    "<span>" +
                    `<div title="Add to Calendar" class="addeventatc general-session-catalog-add-calendar-btn pull-left">
                    ${param["buttonConfig"].calendarButtonLabel}
                    <span class="client">${param['clientKey']}</span> 
                    <span class="start">{@ddf.startTime@}</span>
                    <span class="end">{@ddf.endTime@}</span>
                    <span class="timezone">${param['localTimezoneKey']}</span>
                    <span class="title">{@ddf.sessionTitle@}</span>
                    <span class="description">` + this.generalSessionConfig.catalogConfig.calendar.textConfig.template 
                    + `</span>
                    <span class="location">{@ddf.locationName@}</span>` +
                    `</div>` + 
                    "</span></div>" +
 	                '</div><div class="col-sm-12 col--builder" *ngIf="!showButton[{@ddf.index@}]"><div class="capacity-full"' +
                    ">" +
                    param["buttonConfig"].capacityFullLabel +
                    '</div></div><div class="col-sm-12 col--builder" *ngIf=\'showAddToCart[{@ddf.index@}] && showButton[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    '\'><div *ngIf="!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}] && !isViewOnly[{@ddf.index@}]" title="Add Session to Cart" (cclClick)=\'addSessionToCart($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}],"{@ddf.sessionId@}")\'><div class="general-session-catalog-add-cart-btn"' +
                    "><i title='Processing' class='fa fa-spinner fa-spin' *ngIf='!isNotProcessingSession[{@ddf.index@}]'></i><span *ngIf='!isNotProcessingSession[{@ddf.index@}]'>&nbsp;</span><span>" +
                    param["buttonConfig"].cartButtonLabel +
                    "</span></div></div>" +       
 	    	        "</div><div *ngIf='showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}] && !isViewOnly[{@ddf.index@}]'><div class=\"session-header-icon-right\" *ngIf='addToFavourite[{@ddf.index@}]'><i title='Add Session to Favorites' (cclClick)='addSessionToFavourite($event,{@ddf.index@},\"{@ddf.id@}\")' class=\"fa " +
                    param["buttonConfig"].favIconSec +
                    ' pull-right general-session-catalog-button-fav-icon"></i></div><div class="session-header-icon-right" *ngIf=\'!addToFavourite[{@ddf.index@}]\'><i title="Remove Session from Favorites" (cclClick)=\'removeSessionFromFavourite($event,{@ddf.index@},"{@ddf.id@}")\' class="fa ' +
                    param["buttonConfig"].favIcon +
                    ' pull-right general-session-catalog-button-fav-icon"></i></div></div><div class="session-header-icon-right pr-0" *ngIf="!showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    ' && !isWaitListed[{@ddf.index@}] && !isViewOnly[{@ddf.index@}];else flags" class="col-12 session-header-icon-right pr-0"><i title="In Cart" class="fa ' +
                    param["buttonConfig"].cartIcon +
                    ' pull-right general-session-catalog-button-cart-icon"></i></div><ng-template #flags><div class="col-12 session-header-icon-right pr-0">' +
                    this.getSessionRegisteredLabel(param, sessionConfig.catalogConfig.body,this.sharedService.catalogLayoutConfig.generalStyle) +
                    this.getSessionWaitlistedLabel(param, sessionConfig.catalogConfig.body,this.sharedService.catalogLayoutConfig.generalStyle) +
                    "</div></ng-template></div>";
                } 
                
                else {
param["bodyTemplate"] =
                    param["bodyTemplate"] +
                    '<div class="col-sm-12 col--builder" session-capacity-label id="session-capacity-label_{@ddf.id@}" *ngIf="!showButton[{@ddf.index@}]"><div class="capacity-full-card"' +
                    ">" +
                    param["buttonConfig"].capacityFullLabel +
                    '</div></div>' +
 		        '<div *ngIf="isEnrolled[{@ddf.index@}] && (registrationSessionStatusId[{@ddf.index@}] == 1 || registrationSessionStatusId[{@ddf.index@}] == 4) && ' +
 	            param["buttonConfig"].enableAddToCalendarButton +
 	            '" title="Add to Calendar" (cclClick)="labelClick($event)">' +
 	            "<span>" +
 	            `<div title="Add to Calendar" class="addeventatc general-session-catalog-add-calendar-btn pull-left">
 	            ${param["buttonConfig"].calendarButtonLabel}
 	     	    <span class="client">${param['clientKey']}</span> 
 	            <span class="start">{@ddf.startTime@}</span>
 	            <span class="end">{@ddf.endTime@}</span>
 	            <span class="timezone">${param['localTimezoneKey']}</span>
 	            <span class="title">{@ddf.sessionTitle@}</span>
 	            <span class="description">` + this.generalSessionConfig.catalogConfig.calendar.textConfig.template 
 	            + `</span>
 	            <span class="location">{@ddf.locationName@}</span>` +
 	            `</div>` + 
 	            "</span></div>" 
                }

                param["bodyTemplate"] = param["bodyTemplate"].replace(
                    new RegExp("{@ddf.sessionDescription@}", "g"),
                    "<div>{@ddf.&sessionDescription@}</div>"
                );

                param["loggedInAttendee"] = this.sharedService.loggedInAttendee;
            }

            var toggle = [];
            var favFlag = [];
            var showAddToCart = [];
            var sessionData = [];
            var isEnrolled = [];
            var isWaitListed = [];
            var isGoingToBeWaitlisted = [];
            var showButton = [];
            var instanceId = [];
            var isViewOnly = [];
            var registrationSessionStatusId = [];
            var showRecurrenceText = [];
            for (let i = 0; i < this.sessionArrangedList.sessions.length; ++i) {
                toggle.push(true);
                // Do changes for displaying recurring session instance information on UI 
                showRecurrenceText.push(false);
                if(!this.sharedService.isEmptyString(this.sessionArrangedList.sessions[i].sessionRecurrence)) {
                    showRecurrenceText[i] = true;
                    var recurrenceJSON = JSON.parse(this.sessionArrangedList.sessions[i].sessionRecurrence);
                    this.sessionArrangedList.sessions[i].cronDisplayText = recurrenceJSON.cronDisplayText;
                    this.sessionArrangedList.sessions[i].recurringSessionFrequency = recurrenceJSON.cronDisplayText;
                }
                if (this.isLoggedIn) {
                    if (this.sessionArrangedList.sessions[i].break) {
                        let viewOnly = this.sessionArrangedList.sessions[i].viewOnlyAttendeeTypes ? this.sessionArrangedList.sessions[i].viewOnlyAttendeeTypes.split(',') : [];
                        if(viewOnly.findIndex(element => element == this.sharedService.loggedInAttendee.type.id) > -1) {
                            isViewOnly.push(true);
                        } else {
                            isViewOnly.push(false);
                        }
                        instanceId.push(this.sessionArrangedList.sessions[i].id);
                        favFlag.push(!this.sessionArrangedList.sessions[i].isFavouriteSession);
                        showAddToCart.push(!this.sessionArrangedList.sessions[i].isAddedToCart);
                        isEnrolled.push(this.sessionArrangedList.sessions[i].isEnrolled);
                        isWaitListed.push(this.sessionArrangedList.sessions[i].isWaitListed);
                        registrationSessionStatusId.push(
                            this.sessionArrangedList.sessions[i].registrationSessionStatusId
                        );
                        if (
                            this.sessionArrangedList.sessions[i].isVacancy ||
                            this.sessionArrangedList.sessions[i].remaining > 0
                        ) {
                            isGoingToBeWaitlisted.push(false);
                            showButton.push(true);
                        } else if (
                            this.sessionArrangedList.sessions[i].waitlistedLimit == null ||
                            this.sessionArrangedList.sessions[i].waitlistedLimit >
                                this.sessionArrangedList.sessions[i].waitlisted
                        ) {
                            isGoingToBeWaitlisted.push(true);
                            showButton.push(true);
                        } else {
                            isGoingToBeWaitlisted.push(false);
                            showButton.push(false);
                        }
                    } else {
                        favFlag.push(true);
                        showAddToCart.push(true);
                        isEnrolled.push(false);
                        isWaitListed.push(false);
                        isGoingToBeWaitlisted.push(false);
                        showButton.push(false);
                        instanceId.push("");
                        registrationSessionStatusId.push("");
                        isViewOnly.push(false);
                    }
                    sessionData.push(this.sessionArrangedList.sessions[i].break);
                }
            }

            if (this.esPage > 1) {
                this.currentGroupingLevels = { topLevel: "", secondLevel: "", thirdLevel: "" };
                for (let i = 0; i < this.sessionArrangedList.sessions.length; ++i) {
                    if (
                        this.sessionArrangedList.sessions[i].level == "top" &&
                        this.currentGroupingLevels.topLevel === ""
                    ) {
                        this.currentGroupingLevels.topLevel = this.sessionArrangedList.sessions[i].groupProperty;
                        if (this.prevGroupingLevels.topLevel === this.currentGroupingLevels.topLevel) {
                            toggle[i] = false;
                        }
                    } else if (
                        this.sessionArrangedList.sessions[i].level == "second" &&
                        this.currentGroupingLevels.secondLevel === ""
                    ) {
                        this.currentGroupingLevels.secondLevel = this.sessionArrangedList.sessions[i].groupProperty;
                        if (this.prevGroupingLevels.secondLevel === this.currentGroupingLevels.secondLevel) {
                            toggle[i] = false;
                        }
                    } else {
                        if (
                            this.sessionArrangedList.sessions[i].level == "third" &&
                            this.currentGroupingLevels.thirdLevel === ""
                        ) {
                            this.currentGroupingLevels.thirdLevel = this.sessionArrangedList.sessions[i].groupProperty;
                            if (this.prevGroupingLevels.thirdLevel === this.currentGroupingLevels.thirdLevel) {
                                toggle[i] = false;
                            }
                        }
                    }
                }
            }
            this.prevGroupingLevels = { topLevel: "", secondLevel: "", thirdLevel: "" };
            for (let i = this.sessionArrangedList.sessions.length - 1; i >= 0; --i) {
                if (!this.sessionArrangedList.sessions[i].break) {
                    if (
                        this.sessionArrangedList.sessions[i].level == "third" &&
                        this.prevGroupingLevels.thirdLevel === ""
                    ) {
                        this.prevGroupingLevels.thirdLevel = this.sessionArrangedList.sessions[i].groupProperty;
                    } else if (
                        this.sessionArrangedList.sessions[i].level == "second" &&
                        this.prevGroupingLevels.secondLevel === ""
                    ) {
                        this.prevGroupingLevels.secondLevel = this.sessionArrangedList.sessions[i].groupProperty;
                    } else {
                        if (
                            this.sessionArrangedList.sessions[i].level == "top" &&
                            this.prevGroupingLevels.topLevel === ""
                        ) {
                            this.prevGroupingLevels.topLevel = this.sessionArrangedList.sessions[i].groupProperty;
                        }
                    }
                }
            }
            sessionData.push(false);
            toggle.push(false);
            param["toggle"] = toggle;
            param["favFlag"] = favFlag;
            param["showAddToCart"] = showAddToCart;
            param["sessionData"] = sessionData;
            param["isEnrolled"] = isEnrolled;
            param["isWaitListed"] = isWaitListed;
            param["isGoingToBeWaitlisted"] = isGoingToBeWaitlisted;
            param["showButton"] = showButton;
            param["instanceId"] = instanceId;
            param["isViewOnly"] = isViewOnly;
            param["registrationSessionStatusId"] = registrationSessionStatusId;
            param["showRecurrenceText"] = showRecurrenceText;

            if (this.sharedService.catalogLayoutConfig.generalStyle == "card"
            ) {
                let sessionCard = ""
                if(this.sharedService.catalogLayoutConfig.filterPlacement == 'left') {
                    sessionCard =  "session-card-left"
                } else {
                    sessionCard =  "session-card-slider"
                }
                this.output = this.mustache.render(
                    `<div class="row row--builder">{@ddf.#sessions@}<div *ngIf='{@ddf.break@} && isNotExcluded[{@ddf.index@}]'  [ngClass]="{\'${sessionCard} \': true,` +
                    `'${param["class"]}-catalog-header-region': toggle[{@ddf.index@}], ` +
                    `'${param["class"]}-catalog-body-region': !toggle[{@ddf.index@}]` +
                        '}" '+
                        "" +
                        " >" +
                        //header section
                        "<div class='col-sm-12 header-height'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '">' +
                        '<img *ngIf=\'("thumbnail_img" === "' +
                        param["headerImgBasedOn"] +
                        '")\' alt="Session Image" class="img-fluid" [src]="\'thumbnail_img\'!=\'' +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '">' +
                        '<img *ngIf=\'("dynamic_img" === "' +
                        param["headerImgBasedOn"] +
                        '" || "speaker_img" === "' + param["headerImgBasedOn"] + '")\' alt="Session Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '">' +
                        '</div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" ><div class='img-full-width ta-center' *ngIf=\"'" +
                        param["headerbannerImageType"] +
                        "'=='thumbnail_img'\" ><img alt=\"Banner Image\"  [src]=\"getImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-header-img card-thumbnail-img-dimension` +
                        '"><span class="thumb-display-icon"> ' + 
                        param["headerPlayIconTemplate"] +
                        "</span></div><div class='img-full-width ta-center' *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\"><img alt=\"Banner Image\"   src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"> </div>' +
                        '</div>' +
                        "<div title='Show Session Details' (cclClick)='toggleView($event,{@ddf.idx@});openBodyModal({@ddf.id@});' {@ddf.resetIndex@} class='session-info-container " +
                        `${param["class"]}-header-text-style ` +
                        `${param["class"]}-header-text-style-no-image-or-banner-or-card'` +
                        ">" +
                        param["headerTemplate"] +
                        "</div>" +
                        "</div>" +
                        "</div>" +
                        '</div> <div class="minw-100" *ngIf="!{@ddf.break@} && isNotExcluded[{@ddf.index@}]"><label class="{@ddf.level@} {@ddf.styleStr@}">{@ddf.groupProperty@}</label></div><p hidden>{@ddf.idx@}</p>{@ddf./sessions@}</div>',
                    this.sessionArrangedList
                );
            } else {
                this.output = this.mustache.render(
                    '{@ddf.#sessions@}<div *ngIf="{@ddf.break@} && isNotExcluded[{@ddf.index@}]" [ngClass]="{\'cursor-pointer\': true, ' +
                        "'attendee-session-list-container': 'l_banner' != '" +
                        param["layout"] +
                        "', " +
                        `'${param["class"]}-catalog-header-region': toggle[{@ddf.index@}], ` +
                        `'${param["class"]}-catalog-body-region': !toggle[{@ddf.index@}]` +
                        '}" id="' +
                        param["type"] +
                        "{@ddf.idx@}\" {@ddf.resetIndex@} " +
                        ">" +
                        //header section
                        "<div *ngIf='toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"></div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='banner-image ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerbannerImageType"] +
                        "'=='thumbnail_img'\" [src]=\"getImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-header-img list-thumbnail-img-dimension` +
                        '"> <span class="thumb-display-icon">' + 
                        param["headerPlayIconTemplate"] +
                        "</span><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\"  src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"> ' +
                        '</div>' +
                        "<div title='Show Session Details' (cclClick)='toggleView($event,{@ddf.idx@});' {@ddf.resetIndex@} class='attendee-session-list-text-container " +
                        `${param["class"]}-catalog-header-text` +
                        "'>" +
                        param["headerTemplate"] +
                        "</div>" +
                        "</div></div>" +
                        //body section
                        "<div *ngIf='!toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-body-container` +
                        '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["bodyImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["bodyDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-body-img` +
                        '"></div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='banner-image ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["bodyBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["bodyBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-body-img` +
                        '"> ' +
                        "<img alt=\"Banner Image\" *ngIf=\"'" +
                        param["bodybannerImageType"] +
                        "'=='thumbnail_img'\" [src]=\"getBodyImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-body-img list-thumbnail-img-dimension` +
                        '"> <span class="thumb-display-icon">' + 
                        param["bodyPlayIconTemplate"] +
                        '</span></div>' +
                        "<div title='Collapse Session Details' (cclClick)='toggleView($event,{@ddf.idx@})' {@ddf.resetIndex@} class='attendee-session-list-text-container " +
                        `${param["class"]}-catalog-body-text` +
                        "'>" +
                        param["bodyTemplate"] +
                        "</div>" +
                        "</div></div>" +
                        '</div> <div *ngIf="!{@ddf.break@} && isNotExcluded[{@ddf.index@}]"><label class="{@ddf.level@} {@ddf.styleStr@}">{@ddf.groupProperty@}</label></div><p hidden>{@ddf.idx@}</p>{@ddf./sessions@}',
                    this.sessionArrangedList
                );
            }

            this.createComponentFromRaw(param, this.output, this.mustache, this.sessionArrangedList, list, listRef);
        } else {
            var toggle = [];
            var showRecurrenceText = [];
            var listSess = this.sessionList["sessions"];
            for (let i = 0; i < listSess.length; ++i) {
                toggle.push(true);
                showRecurrenceText.push(false);
                if(!this.sharedService.isEmptyString(listSess[i].sessionRecurrence)) {
                    showRecurrenceText[i] = true;
                    var recurrenceJSON = JSON.parse(listSess[i].sessionRecurrence);
                    listSess[i].cronDisplayText = recurrenceJSON.cronDisplayText;
                    listSess[i].recurringSessionFrequency = recurrenceJSON.cronDisplayText;
                }
            }
            param["toggle"] = toggle;
            if ((this.sharedService.catalogLayoutConfig.promotedStyle == "card") ||
            (this.sharedService.catalogLayoutConfig.highlightedStyle == "card")) {
                displayAs = "all_session";
            }
            if (displayAs != "1_carousel") {
                if ((this.sharedService.catalogLayoutConfig.listType == 'promoted' && this.sharedService.catalogLayoutConfig.promotedStyle == "card") ||
                (this.sharedService.catalogLayoutConfig.listType == 'magazine' && this.sharedService.catalogLayoutConfig.highlightedStyle == "card")) {
                    let sessionCard = ""
                if(this.sharedService.catalogLayoutConfig.filterPlacement == 'left') {
                    sessionCard =  "session-card-left"
                } else {
                    sessionCard =  "session-card-slider"
                }

                if(type == 'promoted') {
                    this.temppromotedList = this.sessionList
                } else if(type == 'highlighted') {
                    this.temphighlightedList = this.sessionList
                }

                    this.output = this.mustache.render(
                        "<div class='row row--builder'>{@ddf.#sessions@}<div " +
                        `class='${sessionCard} ` +
                        `${param["class"]}-catalog-header-region` +
                        "' >" +
                        //header section
                        "<div {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '"><img *ngIf=\'("dynamic_img" === "' +
                        param["headerImgBasedOn"] +
                        '" || "speaker_img" === "' + param["headerImgBasedOn"] + '")\' alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"></div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" >" +
                        "<div class='row img-pos ta-center' *ngIf=\"'" +
                        param["headerbannerImageType"] +
                        "'=='thumbnail_img'\">" +
                        "<img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerbannerImageType"] +
                        "'=='thumbnail_img'\" [src]=\"getImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-header-img card-thumbnail-img-dimension` +
                        '"> <span class="thumb-display-icon">' + 
                        param["headerPlayIconTemplate"] +
                        "</span></div>" +
                        "<div class='row img-pos ta-center'*ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\" ><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\"  src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"> </div>' +
                        '</div>' +
                        "<div title='Show Session Details' (cclClick)='toggleView($event,{@ddf.idx@});openBodyModal({@ddf.id@});' {@ddf.resetIndex@} class='session-info-container " +
                        `${param["class"]}-header-text-style ` +
                        `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                        "'>" +
                        param["headerTemplate"] +
                        "</div></div></div>" +
                        "</div><p hidden>{@ddf.idx@}</p>{@ddf./sessions@}",
                        this.sessionList
                    );
                } else {
                this.output = this.mustache.render(
                    "{@ddf.#sessions@}<div [ngClass]=\"{'cursor-pointer': true, " +
                        "'attendee-session-list-container': 'l_banner' != '" +
                        param["layout"] +
                        "', " +
                        `'${param["class"]}-catalog-header-region': toggle[{@ddf.index@}], ` +
                        `'${param["class"]}-catalog-body-region': !toggle[{@ddf.index@}]` +
                        '}" id="' +
                        param["type"] +
                        "{@ddf.idx@}\" {@ddf.resetIndex@} title='Show Session Details'  (cclClick)='toggleView($event,{@ddf.idx@})' {@ddf.resetIndex@}" +
                        ">" +
                        //header section
                        "<div *ngIf='toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        '\'" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"></div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='banner-image ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"> '+
                        "<img alt=\"Bannersss Image\" *ngIf=\"'" +
                        param["headerbannerImageType"] +
                        "'=='thumbnail_img'\" [src]=\"getImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-header-img list-thumbnail-img-dimension` +
                        '"> <span class="thumb-display-icon">' + 
                        param["headerPlayIconTemplate"] +
                        '</span> </div>' +
                        "<div title='Show Session Details' (cclClick)='toggleView($event,{@ddf.idx@})' {@ddf.resetIndex@} class='attendee-session-list-text-container " +
                        `${param["class"]}-catalog-header-text` +
                        "'>" +
                        param["headerTemplate"] +
                        "</div>" +
                        "<div title='Session Instances Menu' class='session-instances-header-icon-right' (cclClick)=\"toggleSessionInstances($event, '{@ddf.sessionId@}');\"><i title='Instances' class='fa fa-bars'></i></div>" +
                        "</div></div>" +
                        //body section
                        "<div *ngIf='!toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-body-container` +
                        '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["bodyImgBasedOn"] +
                        "'?('{@ddf.speakers.0.speakerAvatar@}'.length > 0 ?'{@ddf.speakers.0.speakerAvatar@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["bodyDynamicImg"] +
                        '\'" [ngClass]="' +
                        `'${param["class"]}-catalog-body-img'` +
                        '"></div>' +
                        "<div title='View Session' (cclClick)=\"openModal('login');gotoURL({@ddf.id@});\" *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='banner-image ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["bodyBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["bodyBanner"] +
                        '" [ngClass]="' +
                        `'${param["class"]}-catalog-body-img'` +
                        '"> ' +
                        "<img alt=\"Banner Image\" *ngIf=\"'" +
                        param["bodybannerImageType"] +
                        "'=='thumbnail_img'\" [src]=\"getBodyImage({@ddf.id@})\"" +
                        ' class=\"' +
                        `${param["class"]}-catalog-body-img list-thumbnail-img-dimension` +
                        '"> <span class="thumb-display-icon">' + 
                        param["bodyPlayIconTemplate"] +
                        '</span></div>' +
                        "<div title='Collapse Session Details' (cclClick)='toggleView($event,{@ddf.idx@})' {@ddf.resetIndex@} class='attendee-session-list-text-container " +
                        `${param["class"]}-catalog-body-text` +
                        "'>" +
                        param["bodyTemplate"] +
                        "</div>" +
                        "<div title='Session Instances Menu' class='session-instances-header-icon-right' (cclClick)=\"toggleSessionInstances($event, '{@ddf.sessionId@}');\"><i title='Instances' class='fa fa-bars'></i></div>" +
                        "</div></div>" +
                        "</div><p hidden>{@ddf.idx@}</p>{@ddf./sessions@}",
                    this.sessionList
                );
                }

                this.createComponentFromRaw(param, this.output, this.mustache, this.sessionList, list, listRef);
            } else {
                this.sessionList["sessions"].forEach((element) => {
                    element.startTime = this.datePipe.transform(
                        element.startTime.replace(new RegExp(" ", "g"), "T"),
                        this.generalDataConfig.dateTimeFormats.dateFormat +
                            "," +
                            this.generalDataConfig.dateTimeFormats.timeFormat
                    );
                    element.endTime = this.datePipe.transform(
                        element.endTime.replace(new RegExp(" ", "g"), "T"),
                        this.generalDataConfig.dateTimeFormats.timeFormat
                    );
                    this.slideRender(param, element, type);
                });
            }
        }
    }

    

    createTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage, dynamicImage, param) {
        if (param["layout"] != "l_noimage" && param["layout"] != "l_banner") {
            let imagePath = "assets/images/blank_profile.jpg";
            if (imageBasedOn === "speaker_img" && speaker != undefined) {
                if (speaker.speakerAvatar) {
                    imagePath = speaker.speakerAvatar;
                }
            }
            if (imageBasedOn === "dynamic_img") {
                if (dynamicImage != "") {
                    imagePath = dynamicImage;
                }
            }
            return (
                '<div class="attendee-session-list-img-container flex-unset ' +
                `${param["class"]}-catalog-header-container` +
                '"><img alt="Speaker Image" class="img-fluid ' +
                `${param["class"]}-catalog-header-img` +
                '" src="' +
                imagePath +
                '"></div>' +
                "<div class='attendee-session-list-text-container " +
                `${param["class"]}-catalog-header-text` +
                "' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        } else {
            return (
                (param["layout"] === "l_banner" && bannerImage != undefined
                    ? '<div class="w-99"><center><img alt="Banner Image" src="' +
                      bannerImage +
                      `" class="${param["class"]}-catalog-header-img"></center></div>`
                    : "") +
                "<div class='attendee-session-list-text-container " +
                `${param["class"]}-catalog-header-text` +
                "' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        }
    }

    slideRender(param, session, type) {
        {
            param["headerStyleStr"] = param["headerStyleStr"].replace(/,/g, "; ");
            param["headerStyleStr"] = param["headerStyleStr"].replace(/[{}']/g, "");
            param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
            param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");
            param["headerTextStyleStr"] = param["headerTextStyleStr"].replace(/,/g, "; ");
            param["headerTextStyleStr"] = param["headerTextStyleStr"].replace(/[{}']/g, "");
            param["headerTemplate"] = param["headerTemplate"]
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");

            param["class"] = `${type}-session`;
            var output = mustache.render(
                this.createTemplate(
                    param["headerImgStyle"],
                    param["headerTextStyleStr"],
                    param["headerTemplate"],
                    session.speakers[0],
                    param["headerImgBasedOn"],
                    param["headerBanner"],
                    param["headerDynamicImg"],
                    param
                ),
                session
            );

            if (type === "promoted") {
                if (this.promotedHasSlide) {
                    this.promotedCarousel.push({ content: output });
                } else {
                    this.promotedCarousel[0].content = output;
                    this.promotedHasSlide = true;
                }
            } else {
                if (this.highlightedHasSlide) {
                    this.highlightedCarousel.push({ content: output });
                } else {
                    this.highlightedCarousel[0].content = output;
                    this.highlightedHasSlide = true;
                }
            }
        }
    }

    reduceHelper(array, filter, sortingBy) {
        if(sortingBy == 'dateTime' || sortingBy == 'date') {
            this.sortByDate(array)
        }
        return array.reduce((map, obj) => {
            let subEl = obj[filter];
            if(!subEl) {
                let temp = obj.customFields.length > 0 ? obj.customFields.find(element => element.code == filter)?.responses[0]?.confFieldOptionCode : null;
                if(temp) {
                    let filterObj =  this.sharedService.sessionEnumCustomFields.find(element => element.code == filter)
                    subEl = filterObj.options.find(ele => ele.code.toLowerCase() == temp.toLowerCase())?.name || null
                } else {
                    subEl = null;
                }
            }
            
            if (subEl == null) {
                subEl = "Other sessions";
            }

            if (subEl != "Other sessions") {
                if (sortingBy === "date") {
                    subEl = this.datePipe.transform(
                        subEl.replace(new RegExp(" ", "g"), "T"),
                        this.generalDataConfig.dateTimeFormats.dateFormat
                    );
                } else if (sortingBy === "dateTime") {
                    subEl =
                        this.datePipe.transform(
                            subEl.replace(new RegExp(" ", "g"), "T"),
                            this.generalDataConfig.dateTimeFormats.dateFormat
                        ) +
                        " " +
                        this.datePipe.transform(
                            subEl.replace(new RegExp(" ", "g"), "T"),
                            this.generalDataConfig.dateTimeFormats.timeFormat
                        );
                }
            }

            if (!map[subEl]) {
                map[subEl] = [];
            }
            map[subEl].push(obj);
            return map;
        }, {});
    }

    setFilter(val, timeFilter) {
        let filter;
        if (val === "date" || val === "dateTime") {
            filter = "startTime";
            this.timeFilter = timeFilter;
        } else if (val === "track") {
            filter = "trackName";
        } else if (val === "type") {
            filter = "typeName";
        } else {
            filter = val;
        }
        return filter;
    }

    groupingSession() {
        let mainFilter = "";
        let secFilter = "";
        let thirdFilter = "";
        if (this.generalDataConfig.topLevel.sortingBy != null) {
            mainFilter = this.setFilter(this.generalDataConfig.topLevel.sortingBy, "topLevel");
            if (this.generalDataConfig.secondLevel.sortingBy != null) {
                secFilter = this.setFilter(this.generalDataConfig.secondLevel.sortingBy, "secondLevel");
                if (this.generalDataConfig.thirdLevel.sortingBy != null) {
                    thirdFilter = this.setFilter(this.generalDataConfig.thirdLevel.sortingBy, "thirdLevel");
                }
            }
            let firstLevelMap = this.reduceHelper(
                this.sessionList["sessions"],
                mainFilter,
                this.generalDataConfig.topLevel.sortingBy
            );
            let secondLevelMap: any = {};

            if (secFilter != "") {
                Object.keys(firstLevelMap).forEach((key) => {
                    let value = firstLevelMap[key];
                    secondLevelMap[key] = this.reduceHelper(
                        value,
                        secFilter,
                        this.generalDataConfig.secondLevel.sortingBy
                    );
                });
            }
            if (thirdFilter != "") {
                Object.keys(secondLevelMap).forEach((key) => {
                    let value = secondLevelMap[key];
                    let thirdLevelMap: any = {};
                    Object.keys(value).forEach((key) => {
                        let list = value[key];
                        thirdLevelMap[key] = this.reduceHelper(
                            list,
                            thirdFilter,
                            this.generalDataConfig.thirdLevel.sortingBy
                        );
                    });
                    secondLevelMap[key] = thirdLevelMap;
                });
            }
            if (secFilter != "" || thirdFilter != "") {
                this.sessionGroupList = secondLevelMap;
            } else {
                this.sessionGroupList = firstLevelMap;
            }

            if(!this.generalDataConfig.hasOwnProperty('sort') || (this.generalDataConfig.hasOwnProperty('sort') && this.generalDataConfig.sort.primarySort == '')) {
                for (const property in this.sessionGroupList) {
                    if(this.sessionGroupList[property].length > 1) {
                        this.sortByDate(this.sessionGroupList[property]);
                    }
                }
            }

            if(this.generalDataConfig.hasOwnProperty('sort') && this.generalDataConfig.sort.primarySort) {
                let sortBy = this.setSorting(this.generalDataConfig.sort.primarySort);
                if(sortBy == 'trackName' || sortBy == 'typeName' || sortBy == 'sessionTitle') {
                    for (const topLevelProp in this.sessionGroupList) {
                        if(this.generalDataConfig.thirdLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                for (const thirdLevelProp in this.sessionGroupList[topLevelProp][secondLevelProp]) {
                                    this.sortStandardFields(this.sessionGroupList[topLevelProp][secondLevelProp][thirdLevelProp], sortBy)
                                }
                            }
                        } else if(this.generalDataConfig.secondLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                this.sortStandardFields(this.sessionGroupList[topLevelProp][secondLevelProp], sortBy)
                            }
                        } else {
                            this.sortStandardFields(this.sessionGroupList[topLevelProp], sortBy)      
                        }
                    }
                } else if(sortBy != 'dateTime') {
                    for (const topLevelProp in this.sessionGroupList) {
                        if(this.generalDataConfig.thirdLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                for (const thirdLevelProp in this.sessionGroupList[topLevelProp][secondLevelProp]) {
                                    this.sortCustomFields(this.sessionGroupList[topLevelProp][secondLevelProp][thirdLevelProp], sortBy)
                                }
                            }
                        } else if(this.generalDataConfig.secondLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                this.sortCustomFields(this.sessionGroupList[topLevelProp][secondLevelProp], sortBy)
                            }
                        } else {
                            this.sortCustomFields(this.sessionGroupList[topLevelProp], sortBy)      
                        }
                    }
                } else {
                    for (const topLevelProp in this.sessionGroupList) {
                        if(this.generalDataConfig.thirdLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                for (const thirdLevelProp in this.sessionGroupList[topLevelProp][secondLevelProp]) {
                                    this.sortByDate(this.sessionGroupList[topLevelProp][secondLevelProp][thirdLevelProp])
                                }
                            }
                        } else if(this.generalDataConfig.secondLevel.sortingBy) {
                            for (const secondLevelProp in this.sessionGroupList[topLevelProp]) {
                                this.sortByDate(this.sessionGroupList[topLevelProp][secondLevelProp])
                            }
                        } else {
                            this.sortByDate(this.sessionGroupList[topLevelProp])      
                        }
                    }
                }
            }

            this.arrangeData(this.sessionGroupList);
        }
    }

    sortStandardFields(grouplist, sortBy) {
        grouplist.sort(( a, b ) => {
            let a1 = a[sortBy] ? a[sortBy].toLowerCase() : ''
            let b1 = b[sortBy] ? b[sortBy].toLowerCase() : ''
            let order1 = a1 > b1;
            let order2 = a1 < b1;
            if(this.generalDataConfig.sort.primarySortOrder == 'desc') {
                order1 = a1 < b1;
                order2 = a1 > b1;
            }
            if ( order1 ) {
                return 1;
            }
            if ( order2 ) {
                return -1;
            }

            // for second level sorting
            let date1 = new Date(a.startTime);
            let date2 = new Date(b.startTime);
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
        });
    }

    sortCustomFields(grouplist, sortBy) {
        grouplist.sort(( a, b ) => {
            let a1 = '';
            let b1 = '';
            if(a.customFieldMap) {
                a1 = a.customFieldMap[sortBy] || ''
            }

            if(b.customFieldMap) {
                b1 = b.customFieldMap[sortBy] || ''
            }

            let order1 = a1 > b1;
            let order2 = a1 < b1;
            if(this.generalDataConfig.sort.primarySortOrder == 'desc') {
                order1 = a1 < b1;
                order2 = a1 > b1;
            }
            if ( order1 ) {
            return 1;
            }
            if ( order2 ) {
            return -1;
            }

            // for second level sorting
            let date1 = new Date(a.startTime);
            let date2 = new Date(b.startTime);
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
        })
    }

    setSorting(value) {  
        switch (value) {
            case 'track':
                return 'trackName'
            case 'title':
                return 'sessionTitle'
            case 'type':
                return 'typeName'
            case '':
                return 'dateTime'
            default:
                return value
        }  
    };

    sortByDate(sessionList) {
        sessionList.sort(function(a, b) {
            let date1 = new Date(a.startTime);
            let date2 = new Date(b.startTime);
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
        });​
    }

    getLabelStyletr(textConfig) {
        return (
            "background-color: " +
            textConfig.backgroundColor +
            ";" +
            "font-style: " +
            textConfig.fontStyle +
            ";" +
            "text-decoration: " +
            textConfig.fontStyle +
            ";" +
            "font-weight: " +
            textConfig.fontStyle +
            ";" +
            "font-size: " +
            textConfig.fontSize +
            "px" +
            ";" +
            "color: " +
            textConfig.fontColor
        );
    }

    async arrangeData(sessionGroupList) {
        let tempType = await this.sessionService.getSessionTypes(this.sharedService.event.id);
        let sessionTypes: any= tempType['body'];
        let tempTrack = await this.sessionService.getSessionTracks();
        let sessionTrack: any = tempTrack.body["data"];
        this.sessionArrangedList = [];
        let arrangeList = [];
        if(this.generalDataConfig.topLevel.sortingBy == 'track' || this.generalDataConfig.topLevel.sortingBy == 'type') {
            this.keysSession = Object.keys(sessionGroupList).sort();
        } else {
            this.keysSession = Object.keys(sessionGroupList);
        }

        if (this.generalDataConfig.topLevel.sortingBy != null) {
            Object.keys(this.keysSession).forEach((item) => {
                var l1 = this.keysSession[item];
                var lvl1 = sessionGroupList[l1];
                this.getKey(sessionGroupList[l1]);

                arrangeList.push({
                    type: "metadata",
                    break: false,
                    level: "top",
                    groupProperty: l1,
                    styleStr: "general-data-topLevel-text"
                });

                if (this.generalDataConfig.secondLevel.sortingBy != null) {
                    let keys = []
                    if(this.generalDataConfig.secondLevel.sortingBy == 'type') {
                        sessionTypes.forEach(element => {
                            if(Object.keys(sessionGroupList[l1]).find(ele => ele == element.sessionType)) {
                                keys.push(element.sessionType);
                            }
                        })
                    } else if(this.generalDataConfig.secondLevel.sortingBy == 'track') {
                        sessionTrack.forEach(element => {
                            if(Object.keys(sessionGroupList[l1]).find(ele => ele == element.trackName)) {
                                keys.push(element.trackName);
                            }
                        })
                    } else if(this.generalDataConfig.secondLevel.sortingBy != 'date' && this.generalDataConfig.secondLevel.sortingBy != 'dateTime') {
                        let obj = this.sharedService.sessionEnumCustomFields.find(element => element.code == this.generalDataConfig.secondLevel.sortingBy);
                        obj.options.sort(function(a, b) {
                            return a.order - b.order;
                        });

                        obj.options.forEach(element => {
                            if(Object.keys(sessionGroupList[l1]).find(ele => ele == element.name)) {
                                keys.push(element.name);
                            }
                        });
                    }

                    if((this.generalDataConfig.secondLevel.sortingBy == 'date' || this.generalDataConfig.secondLevel.sortingBy == 'dateTime')) {
                        Object.keys(sessionGroupList[l1]).forEach(element => {
                            keys.push(element);
                        });
                    }
                    if(this.generalDataConfig.secondLevel.sortingBy == 'track' || this.generalDataConfig.secondLevel.sortingBy == 'type' || (this.generalDataConfig.secondLevel.sortingBy != 'date' && this.generalDataConfig.secondLevel.sortingBy != 'dateTime')) {
                        Object.keys(sessionGroupList[l1]).forEach((e) => {
                            if(e == 'Other sessions') {
                                keys.push('Other sessions')
                            }
                        })
                    }

                    keys.forEach((lvl2) => {
                        var l2 = sessionGroupList[l1][lvl2];
                        arrangeList.push({
                            type: "metadata",
                            break: false,
                            level: "second",
                            groupProperty: lvl2,
                            styleStr: "general-data-secondLevel-text"
                        });
                        this.getKey(sessionGroupList[l1][lvl2]);
                        if (this.generalDataConfig.thirdLevel.sortingBy != null) {
                            let tkeys = []
                            if(this.generalDataConfig.thirdLevel.sortingBy == 'type') {
                                sessionTypes.forEach(element => {
                                    if(Object.keys(sessionGroupList[l1][lvl2]).find(ele => ele == element.sessionType)) {
                                        tkeys.push(element.sessionType);
                                    }
                                })
                            } else if(this.generalDataConfig.thirdLevel.sortingBy == 'track') {
                                
                                sessionTrack.forEach(element => {
                                    if(Object.keys(sessionGroupList[l1][lvl2]).find(ele => ele == element.trackName)) {
                                        tkeys.push(element.trackName);
                                    }
                                })
                            } else if(this.generalDataConfig.thirdLevel.sortingBy != 'date' && this.generalDataConfig.thirdLevel.sortingBy != 'dateTime') {
                                let obj = this.sharedService.sessionEnumCustomFields.find(element => element.code == this.generalDataConfig.thirdLevel.sortingBy);
                                obj.options.sort(function(a, b) {
                                    return a.order - b.order;
                                });
                                
                                obj.options.forEach(element => {
                                    if(Object.keys(sessionGroupList[l1][lvl2]).find(ele => ele == element.name)) {
                                        tkeys.push(element.name);
                                    }
                                });
                            }
                            
                            if((this.generalDataConfig.thirdLevel.sortingBy == 'date' || this.generalDataConfig.thirdLevel.sortingBy == 'dateTime')) {
                                Object.keys(sessionGroupList[l1][lvl2]).forEach(element => {
                                    tkeys.push(element);
                                });
                            }

                            if(this.generalDataConfig.thirdLevel.sortingBy == 'track' || this.generalDataConfig.secondLevel.sortingBy == 'type' || (this.generalDataConfig.thirdLevel.sortingBy != 'date' && this.generalDataConfig.thirdLevel.sortingBy != 'dateTime')) {
                                Object.keys(sessionGroupList[l1][lvl2]).forEach((e) => {
                                    if(e == 'Other sessions') {
                                        tkeys.push('Other sessions')
                                    }
                                })
                            }
                            tkeys.forEach((lvl3) => {
                                var l3 = sessionGroupList[l1][lvl2][lvl3];
                                arrangeList.push({
                                    type: "metadata",
                                    break: false,
                                    level: "third",
                                    groupProperty: lvl3,
                                    styleStr: "general-data-thirdLevel-text"
                                });

                                for (let index = 0; index < l3.length; index++) {
                                    l3[index].break = true;

                                    l3[index].type = "data";
                                    arrangeList.push(l3[index]);
                                }
                            });
                        } else {
                            for (let index = 0; index < l2.length; index++) {
                                l2[index].break = true;

                                l2[index].type = "data";
                                arrangeList.push(l2[index]);
                            }
                        }
                    });
                } else {
                    for (let index = 0; index < lvl1.length; index++) {
                        lvl1[index].break = true;

                        lvl1[index].type = "data";
                        arrangeList.push(lvl1[index]);
                    }
                }
            });
        }

        var idx = 0;
        var fillingFastConfig = this.buttonConfig;

        this.sessionArrangedList = {
            sessions: arrangeList,
            idx: function() {
                return idx++;
            },
            resetIndex: function() {
                idx -= 1;
                return;
            },
            checkNullEmptyString: function() {
                return function(text, render) {
                    if (render(text) == null || render(text) == "") {
                        return false;
                    } else {
                        return render(text);
                    }
                };
            },
            remainingPercentage: function() {
                return function(text, render) {
                    if (render(text) == null || render(text) == "") {
                        return false;
                    } else {
                        if (render(text).substring(0, 4) === "true") {
                            var json: any = {};
                            json = JSON.parse(
                                render(text)
                                    .substring(4)
                                    .replace(":}", ":null}")
                                    .replace(":,", ":null,")
                            );
                            if (
                                json.capacity != "" &&
                                json.remaining != "" &&
                                json.remaining > 0 &&
                                json.capacity > 0
                            ) {
                                if ((json.remaining / json.capacity) * 100 <= fillingFastConfig.fillingFastPercent) {
                                    return fillingFastConfig.fillingFastLabel;
                                }
                            }
                        }
                    }
                };
            },
            index: function() {
                return idx;
            }
        };
        let generalSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SESSION.general].config
        );

        if (this.generalList != null && this.clearGeneralSessionList) {
            this.generalList.clear();
            this.clearGeneralSessionList = false;
        }
        this.listemplateHelper(generalSessionConfig, this.generalList, this.generalListRef, "general", "");
    }

    prepareDateTime(obj) {
        var d1 = this.datePipe.transform(
            obj.replace(new RegExp(" ", "g"), "T"),
            this.generalDataConfig.dateTimeFormats.dateFormat
        );

        var t1 = this.datePipe.transform(
            obj.replace(new RegExp(" ", "g"), "T"),
            this.generalDataConfig.dateTimeFormats.timeFormat
        );
        return d1 + " " + t1;
    }

    getKey(obj) {
        return Object.keys(obj);
    }

    customFieldFileDownloadHelper(template, type) {
        var matches = template.match(new RegExp("({@ddf.customFieldMap.)(.*?)(?=})", "g"));
        matches = uniq(matches);
        if (matches != null && matches.length > 0) {
            matches.forEach((code) => {
                this.customFieldDdfRegx.lastIndex = 0;
                code = this.customFieldDdfRegx.exec(code)[2];
                this.sharedService.sessionFileCustomFields.forEach((element) => {
                    if (code == element.code.replace(/ /g, "") && element.questionTypeId == 19) {
                        var ddf = "{@ddf.customFieldMap." + code + "@}";
                        template = template.replace(
                            new RegExp(ddf, "g"),
                            '<span class="cursor-pointer" title="Download" ' +
                            '(cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}","' +
                                ddf +
                                '","Custom","{@ddf.sessionId@}")\'>' +
                                ddf +
                                " </span>"
                        );
                    }
                });
            });
        }
        let asset_matches = template.match(new RegExp("({#ddf.customFieldMap.)(.*?)(?=})", "g"));
        asset_matches = uniq(asset_matches);
        if(asset_matches != null && asset_matches.length > 0) {
            asset_matches.forEach((codec) => {
                this.assetcustomFieldDdfRegx.lastIndex = 0;
                codec = this.assetcustomFieldDdfRegx.exec(codec)[2];
                let mddf = "{#ddf.customFieldMap." + codec + "#}";
                template = template.replace(
                    new RegExp(mddf, "g"),
                    "{@ddf.customFieldMap." + codec + "@}"
                );
            });
        }
        return template;
    }

    customFieldFileSpeakerDownloadHelper(template) {
        var matches = template.match(new RegExp("({@ddf.customFieldMap.)(.*?)(?=})", "g"));
        matches = uniq(matches);
        if (matches != null && matches.length > 0) {
            matches.forEach((code) => {
                this.customFieldDdfRegx.lastIndex = 0;
                code = this.customFieldDdfRegx.exec(code)[2];
                this.sharedService.speakerFileCustomFields.forEach((element) => {
                    if (code == element.code.replace(/ /g, "") && element.questionTypeId == 19) {
                        var ddf = "{@ddf.customFieldMap." + code + "@}";
                        template = template.replace(
                            new RegExp(ddf, "g"),
                            '<span class="speakerCustomFile cursor-pointer" data-filename="' +
                                ddf +
                                '" data-documentType="Custom" data-eventId="' +
                                this.sharedService.event.id +
                                '" data-speakerId="{@ddf.id@}">' +
                                ddf +
                                " </span>"
                        );
                    }
                });
            });
        }

        return template;
    }

    getSafeHtmlDescStr(template, type) {
        template = template.replace(new RegExp("{@ddf.abstractDesc@}", "g"), "<div>{@ddf.&abstractDesc@}</div>");
        template = template.replace(new RegExp("{@ddf.biography@}", "g"), "{@ddf.&biography@}");
        template = template.replace(
            "{@ddf.webinar.joinBaseUrl@}",
            "<span style='cursor:pointer;' title='Join Base URL' (cclClick)=\"openLINK($event,'{@ddf.webinar.joinBaseUrl@}')\">JOIN BASE URL </span>"
        );

        template = template.replace(
            "{@ddf.webinar.startUrl@}",
            "<span style='cursor:pointer;' title='Start URL' (cclClick)=\"openLINK($event,'{@ddf.webinar.startUrl@}')\"> START URL </span>"
        );

        template = template.replace(
            "{@ddf.webinar.webinarThumbnail@}",
            "<span style='cursor:pointer;' title='Thumbnail URL' (cclClick)=\"openLINK($event,'{@ddf.webinar.webinarThumbnail@}')\"> THUMBNAIL URL </span>"
        );
        if(template.includes("data-if-click")) {
            template = template.replace(
                new RegExp("data-if-click", "g"),   
                '*ngIf="sharedService.loggedInAttendee != null && \'{@ddf.regWebinar.participantJoinUrl@}\'" (cclClick)'
            );
        } else {
            template = template.replace(
                "{@ddf.regWebinar.participantJoinUrl@}",
                "<span style='cursor:pointer;' *ngIf='sharedService.loggedInAttendee != null && registrationSessionStatusId[{@ddf.index@}] == 1 && \"{@ddf.regWebinar.participantJoinUrl@}\"' title='Join URL' (cclClick)=\"openLINK($event,'{@ddf.regWebinar.participantJoinUrl@}')\"> JOIN URL </span>"
            );
        }

        template = template.replace(
            new RegExp("data-if-loggedin=\"\"", "g"),
            '*ngIf="sharedService.loggedInAttendee != null"'
        );

        template = template.replace(
            new RegExp("data-if-loggedin=''", "g"),
            '*ngIf="sharedService.loggedInAttendee != null"'
        );

        template = template.replace(
            new RegExp("data-if-loggedin", "g"),
            '*ngIf="sharedService.loggedInAttendee != null"'
        );

        template = template.replace(
            new RegExp("data-if-public=\"\"", "g"),
            '*ngIf="sharedService.loggedInAttendee == null"'
        );

        template = template.replace(
            new RegExp("data-if-public=''", "g"),
            '*ngIf="sharedService.loggedInAttendee == null"'
        );

        template = template.replace(
            new RegExp("data-if-public", "g"),
            '*ngIf="sharedService.loggedInAttendee == null"'
        );

        template = template.replace(
            new RegExp("data-if", "g"),
            '*ngIf'
        );

        template = template.replace(
            new RegExp("{@ddf.sessionDescription@}", "g"),
            "<div>{@ddf.&sessionDescription@}</div>"
        );

        return template.replace(
            new RegExp("{@ddf.dialinNumbers@}", "g"),
            "<div>{@ddf.&dialinNumbers@}</div>"
        );
        
        
    }

    createStyleString(styleConfig) {
        return (
            "{'margin' : '" +
            styleConfig.regionConfig.margin +
            "'," +
            "'padding': '" +
            styleConfig.regionConfig.padding +
            "'," +
            "'background': '" +
            styleConfig.regionConfig.background +
            "'," +
            "'border-radius': '" +
            styleConfig.regionConfig.corner +
            "'}"
        );
    }

    fromAttedee(list, groupConfig) {
        this.fromAttendee = true;
        var customTags = ["{@ddf.", "@}"];
        this.mustache.tags = customTags;
        this.generalDataConfig = groupConfig;
        this.previewAttendeeSide(list);
    }

    createStyleString2(styleConfig) {
        return {
            margin: styleConfig.regionConfig.margin,
            padding: styleConfig.regionConfig.padding,
            background: styleConfig.regionConfig.background,
            "border-radius": styleConfig.regionConfig.corner
        };
    }

    createTextStyle(styleConfig, imgWidth, imgLayout) {
        return (
            "{'background': '" +
            styleConfig.textConfig.background +
            "'," +
            "'width': '" +
            (imgLayout != "l_noimage" && imgLayout != "l_banner" ? "calc(98% - " + imgWidth + ")" : "100%") +
            "'," +
            "'color': '" +
            styleConfig.textConfig.textColor +
            "'}"
        );
    }

    createImageStyle(styleConfig, layout) {
        if (layout != "l_noimage" && layout != "l_banner") {
            let divStyle =
                "height: " +
                styleConfig.imageConfig.height +
                ";" +
                "width: " +
                styleConfig.imageConfig.width +
                ";" +
                "background: " +
                styleConfig.imageConfig.background +
                ";" +
                "margin: " +
                styleConfig.imageConfig.margin +
                ";" +
                "border-radius: " +
                (layout === "l_circular" ? styleConfig.imageConfig.height : "0px") +
                ";";
            let imgStyle =
                "height: " +
                styleConfig.imageConfig.height +
                ";" +
                "width: " +
                styleConfig.imageConfig.width +
                ";" +
                "border-radius: " +
                (layout === "l_circular" ? styleConfig.imageConfig.height : "0px") +
                ";";
            if (styleConfig.imageConfig.background != null && styleConfig.imageConfig.background.trim().length != 0) {
                imgStyle +=
                    "-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); opacity: 0.80;-moz-opacity: 80%;-webkit-opacity: 80%;";
            }
            return {
                div: divStyle,
                img: imgStyle
            };
        } else if (layout === "l_banner") {
            return {
                div: "",
                img:
                    "height: calc(100% - 2 * " +
                    styleConfig.imageConfig.margin +
                    ");width: calc(100% - 2 * " +
                    styleConfig.imageConfig.margin +
                    ");margin: " +
                    styleConfig.imageConfig.margin +
                    ";"
            };
        } else {
            return {
                div: "",
                img: ""
            };
        }
    }

    ngAfterViewInit(): void {
        if (!this.isLoggedIn && this.sharedService.loginPopup == "open") {
            this.openLoginPopup("login");
        }
    }

    ngOnDestroy() {
        if (this.highlightedListRef) {
            this.highlightedListRef.destroy();
        }
        if (this.promotedListRef) {
            this.promotedListRef.destroy();
        }
        if (this.generalListRef) {
            this.generalListRef.destroy();
        }

        if (this.vcRef) {
            this.vcRef.destroy();
        }
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    openPopup(item) {
        this.sharedService.currentPopup = {
            title: null,
            navLinks: null,
            saveMessage: null,
            showFooter: false
        };
        let url = "popup/default-setup";
        this.sharedService.navigateToOutlet("popup", url);
    }

    showSideBar: boolean = false;
    toggleSideBar() {
        this.showSideBar = !this.showSideBar;
    }

    hideSession(value) {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        if(value.hideFullSession) {
            this.filters.hideFullSessions = value.hideFullSession;
        } else {
            delete this.filters.hideFullSessions;
        }

        if(value.hidePastSession) {
            this.filters.hidePastSession = value.hidePastSession;
        } else {
            delete this.filters.hidePastSession;
        }
        this.getSessionList();
    }

    mySessionCheckbox() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = true;
        this.filters.fetchFavInstanceList = false;
        this.getSessionList();
    }

    myFavCheckbox() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = false;
        this.filters.fetchFavInstanceList = true;
        this.getSessionList();
    }

    mySessionFilterClear() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = false;
        this.filters.fetchFavInstanceList = false;
        this.sharedService.tabChangedDate = '';
    }

    myTimeZone() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.noSessionsAvailable = false;
        this.attendeeSessionService.onTimeZoneChange('promoted');
        this.highlightedLoaded = false;
        this.promotedLoaded = false;
        this.getHighlightedAndPromotedSessions();
        this.attendeeSessionService.onTimeZoneChange('general');
        this.getSessionList();
    }

    @ViewChild("highlightedList", { read: ViewContainerRef })
    highlightedList: ViewContainerRef;

    @ViewChild("promotedList", { read: ViewContainerRef })
    promotedList: ViewContainerRef;

    @ViewChild("generalList", { read: ViewContainerRef })
    generalList: ViewContainerRef;

    @ViewChild('vc', { read: ViewContainerRef })
    vc: ViewContainerRef;

    private highlightedListRef: ComponentRef<any>;
    private promotedListRef: ComponentRef<any>;
    private generalListRef: ComponentRef<any>;
    private vcRef: ComponentRef<any>;


    // Here we create the component.
    private createComponentFromRaw(
        param: any,
        template: string,
        mustache: any,
        sessionList: any,
        compRef: any,
        cmpRef: any
    ) {
        // Let's say your template looks like `<h2><some-component [data]="data"></some-component>`
        // As you see, it has an (existing) angular component `some-component` and it injects it [data]

        // Now we create a new component. It has that template, and we can even give it data.
        template = template.replace(/{/g, '&#123;');
        template = template.replace(/}/g, '&#125;');
        const parentCmp = this;
        template = template
            .replace(new RegExp('contenteditable="true"', "g"), "")
            .replace(new RegExp("contenteditable='true'", "g"), ""); //to remove editable
        @CustomComponent({ template: template, selector: 'scTmpCmp' })
        class tmpCmp {
            isUserLoggedIn:boolean = false;
            params: any = param;
            compiler: Compiler;
            sharedService: SharedService;
            popupService: CclPopupService;

            constructor() {
                this.isUserLoggedIn = param["isLoggedIn"];
            }
            
            
            // the class is anonymous. But it's a quite regular angular class. You could add @Inputs,
            // @Outputs, inject stuff etc.

            createSpeakerTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage) {
                textStyleStr = textStyleStr + ";box-sizing: border-box;padding-right: 15px";
                if (param["speakerLayout"] != "l_noimage" && param["speakerLayout"] != "l_banner") {
                    let imagePath = "assets/images/blank_profile.jpg";
                    if (imageBasedOn === "speaker_img" && speaker != undefined) {
                        if (speaker.avatar != "" && speaker.avatar != null) {
                            imagePath = speaker.avatar;
                        }
                    }
                    if (imageBasedOn === "dynamic_img") {
                        if (param["speakerDynamicImg"] != "") {
                            imagePath = param["speakerDynamicImg"];
                        }
                    }
                    return (
                        '<div class="attendee-session-list-img-container speaker-catalog-body-container">' +
                        '<img alt="Speaker Image" src="' +
                        imagePath +
                        '" class="speaker-catalog-body-img"></div>' +
                        "<div class='attendee-session-list-text-container speaker-catalog-body-text bs-pr' {@ddf.resetIndex@}" +
                        ">" +
                        output2 +
                        "</div>"
                    );
                } else {
                    return (
                        (param["speakerLayout"] === "l_banner" && bannerImage != undefined
                            ? '<div><img alt="Banner Image" src="' +
                              bannerImage +
                              '" class="speaker-catalog-body-img"' +
                              "></div>"
                            : "") +
                        "<div class='attendee-session-list-text-container speaker-catalog-body-text bs-pr' {@ddf.resetIndex@}" +
                        ">" +
                        output2 +
                        "</div>"
                    );
                }
            }

            checkRestricted(isPrivate) {
                if(param['loginConfig'].restrictedBrowsing == true) {
                    return false;
                } else if(isPrivate == true || isPrivate == 'true') {
                    return false;
                } else {
                    return true;
                }
            }

            createSessionTemplate(textStyleStr, output2, session, imageBasedOn, bannerImage, defaultBodyThumbnailURL) {
                //for always using general-speaker classes for biography popup
                // param["class"] = "general-speaker";
                //for always using general-speaker layout for biography popup
                // param["layout"] = param["bioLayout"];
                let joinurl = ""
                if (session.regWebinar && session.regWebinar != null && session.regWebinar.participantJoinUrl != null) {
                    joinurl = session.regWebinar.participantJoinUrl
                }
                textStyleStr = textStyleStr + ";box-sizing: border-box;padding-right: 15px";
                let styleString = ''
                styleString = param["type"] == 'general-' ? "general" : param["type"] == 'highlighted-' ? 'highlighted' : 'promoted'
                if (param["layout"] != "l_noimage" && param["layout"] != "l_banner") {
                    let imagePath = "assets/images/blank_profile.jpg";
                    if (imageBasedOn === "speaker_img" && session.speakers[0] != undefined) {
                        if (session.speakers[0].speakerAvatar) {
                            imagePath = session.speakers[0].speakerAvatar;
                        }
                    }
                    if (imageBasedOn === "dynamic_img") {
                        if (param["bodyDynamicImg"] != "") {
                            imagePath = param["bodyDynamicImg"];
                        }
                    }
                    if (param["sharedService"].catalogLayoutConfig.highlightedStyle == "card" ||
                    param["sharedService"].catalogLayoutConfig.promotedStyle == "card" ||
                    param["sharedService"].catalogLayoutConfig.generalStyle == "card") {
                        return (
                            '<div title="Speaker Image" (cclClick)="openModal(\'login\');gotoURL({@ddf.id@})" class="attendee-session-list-img-container ' +
                            `${param["class"]}-catalog-body-container` +
                            '"><img alt="Speaker Image" src="' +
                            imagePath +
                            '" class="' +
                            `${param["class"]}-catalog-body-img` +
                            '"></div>' +
                            "<div class='session-info-container " +
                            `${param["class"]}-header-text-style ` +
                            `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                            "' {@ddf.resetIndex@}" +
                            ">" +
                            output2 +
                            "</div>"
                        );
                    } else {
                        return (
                                '<div class="cursor-pointer attendee-session-list-container ' +
                            `${param["class"]}-catalog-body-region` +
                            '" ' +
                            ">" +
                            '<div class="' +
                            `${param["class"]}-catalog-body-container catalog-img-container` +
                            '"><img alt="Speaker Image" src="' +
                            imagePath +
                            '" class="' +
                            `${param["class"]}-catalog-body-img` +
                            '"></div>' +
                            "<div class='attendee-session-list-text-container " +
                            `${param["class"]}-catalog-body-text` +
                            "' {@ddf.resetIndex@}" +
                            ">" +
                            output2 +
                            "</div>" +
                            "</div>"
                        );
                    }
                } else {
                    if(imageBasedOn === "dynamic_img") {
                        if(param["sharedService"].catalogLayoutConfig.highlightedStyle == "list" ||
                        param["sharedService"].catalogLayoutConfig.promotedStyle == "list" ||
                        param["sharedService"].catalogLayoutConfig.generalStyle == "list") {
                                let customCss    
                            if(param["layout"] != "l_banner") {
                                    customCss = "attendee-session-list-container"
                                } else {
                                    customCss = ""
                                }
                            
                            return (
                                '<div class="cursor-pointer ' + customCss +
                                ` ${param["class"]}-catalog-body-region` +
                                '" ' +
                                ">" +
                                (param["layout"] === "l_banner" && bannerImage != undefined && bannerImage != ''
                                    ? '<div class="banner-image"><center><img alt="Banner Image" src="' +
                                      bannerImage +
                                      `" class="${param["class"]}-catalog-body-img"></center></div>`
                                    : "") +
                                "<div class='attendee-session-list-text-container " +
                                `${param["class"]}-catalog-body-text` +
                                "' {@ddf.resetIndex@}" +
                                ">" +
                                output2 +
                                "</div>" +
                                "</div>"
                            );
                        } else {
                            return (
                                (param["layout"] === "l_banner" && bannerImage != undefined && bannerImage != ''
                                    ? '<div title="View Session" (cclClick)="openModal(\'login\');gotoURL({@ddf.id@})" class="banner-image"><center><img alt="Banner Image" src="' +
                                    bannerImage +
                                    `" class="${param["class"]}-catalog-header-img"></center></div>`
                                    : "") +
                                "<div class='session-info-container " +
                                `${param["class"]}-header-text-style ` +
                                `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                                "' {@ddf.resetIndex@}" +
                                ">" +
                                output2 +
                                "</div>"
                            );
                        }
                        
                    } else if(imageBasedOn === "thumbnail_img") {
                        let img;
                        if(session.webinar) {
                            img = session.webinar.webinarThumbnail || defaultBodyThumbnailURL
                        } else {
                            img = defaultBodyThumbnailURL
                        }
                        if(param["sharedService"].catalogLayoutConfig.generalStyle == "list" ||
                        param["sharedService"].catalogLayoutConfig.generalStyle == "list" ||
                        param["sharedService"].catalogLayoutConfig.generalStyle == "list") {
                        return (
                            '<div class="cursor-pointer ' +
                                ` ${param["class"]}-catalog-body-region` +
                                '" ' +
                                ">" +
                            (param["layout"] === "l_banner" && img != undefined && img != ''
                                ? '<div class="banner-image"><center><img alt="Banner Image" src="' +
                                img +
                                  `" class="${param["class"]}-catalog-body-img"><span class="thumb-display-icon">` + 
                                  param["bodyPlayIconTemplate"] +
                                  `</span></center></div>`
                                : "") +
                            "<div class='attendee-session-list-text-container " +
                            `${param["class"]}-catalog-body-text` +
                            "' {@ddf.resetIndex@}" +
                            ">" +
                            output2 +
                            "</div>" +
                            "</div>"
                        );
                        } else {
                            return (
                                (param["layout"] === "l_banner" && img != undefined && img != ''
                                    ? '<div title="View Session" (cclClick)="openModal(\'login\');gotoURL({@ddf.id@})" class="banner-image"><center><img alt="Banner Imagess" src="' +
                                    img +
                                    `" class="${param["class"]}-catalog-header-img list-thumbnail-img-dimension"><span class="thumb-display-icon">` +
                                    param["bodyPlayIconTemplate"] +
                                    `</span></center></div>`
                                    : "") +
                                "<div class='session-info-container " +
                                `${param["class"]}-header-text-style ` +
                                `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                                "' {@ddf.resetIndex@}" +
                                ">" +
                                output2 +
                                "</div>"
                            ); 
                        }
                    } else {
                        return (
                            "<div class='session-info-container " +
                            `${param["class"]}-header-text-style ` +
                            `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                            "' {@ddf.resetIndex@}" +
                            ">" +
                            output2 +
                            "</div>"
                        ); 
                    }
                    
                }
            }

            downloadSessionDocument(event, eventId, documentName, documentType, sessionId) {
                event.stopPropagation();
                if (documentName) {
                param["attendeeSessionService"]
                    .downloadSessionDocument(eventId, documentName, documentType, sessionId)
                    .subscribe((resp) => {
                        FileSaver.saveAs(resp.body, documentName);
                    });
            }
            }

            viewSessionDocument(event, documentURL) {
                event.preventDefault();
                event.stopPropagation();
                if(documentURL && documentURL != null) {
                    window.open(documentURL, "_blank");
                } else {
                    param["_flashMessagesService"].show("No URL Provided.", { 
                        cssClass: "alert-danger"
                    });
                    return false;
                }
            }

            checkIfDDFExist(value,id) {
                return document.querySelectorAll('ul.' + value + '-' + id + ' li').length == 0 ? true : false; 
            }

            openBodyModal(id) {
                
                let session = sessionList.sessions.find(obj => {
                    return obj.id == id
                })

                let indexOfSession = sessionList.sessions.findIndex(i => i.id == id);

                let tempSession;
                tempSession = cloneDeep(session)
                tempSession.index = indexOfSession

                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");
                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");

                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/[{}']/g, "");
                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/,/g, "; ");
                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/,/g, "; ");
                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/[{}']/g, "");

                var output = mustache.render(
                    this.createSessionTemplate(
                        param["bodyTextStyleStr"],
                        param["bodyTemplate"],
                        tempSession,
                        param["bodyImgBasedOn"],
                        param["bodyBanner"] || "",
                        param['defaultBodyThumbnailURL'] || ""
                    ),
                    tempSession
                );
 
                const modalData: Object = {
                    sessionModalHeader: param["sessionModalHeader"],
                    modalContent: output,
                    sessionData: tempSession,
                    sessionList: sessionList
                };
                
                cardpop.PopUp({
                    modalData: modalData,
                    param: param
                });
            }

            openModel(event, speakerUsername, eventUUID, index) {
                if(param['speakerConfig']['catalogConfig']['enableSpeakerPopup'] == false) {
                    return;
                }
                event.stopPropagation();
                var speaker;
                param["attendeeSessionService"].getSpeaker(speakerUsername, eventUUID).subscribe(
                    (resp) => {
                        param["modalService"].close("sessionModal");
                        if (resp.hasOwnProperty("body")) {
                            speaker = resp.body;
                            var customFieldMap = {};
                            if (speaker.customFieldCodeMap != null) {
                                Object.keys(speaker.customFieldCodeMap).forEach((key) => {
                                    let keyVal = speaker.customFieldCodeMap[key].split(" : ");
                                    customFieldMap[key.replace(/ /g, "")] = keyVal[1];
                                });
                            }
                            speaker.customFieldMap = customFieldMap;
                            param["speakerStyleStr"] = param["speakerStyleStr"].replace(/,/g, "; ");
                            param["speakerStyleStr"] = param["speakerStyleStr"].replace(/[{}']/g, "");
                            param["speakerStyleStr"] = param["speakerStyleStr"].replace(/,/g, "; ");
                            param["speakerStyleStr"] = param["speakerStyleStr"].replace(/[{}']/g, "");

                            param["speakerTextStyleStr"] = param["speakerTextStyleStr"].replace(/[{}']/g, "");
                            param["speakerTextStyleStr"] = param["speakerTextStyleStr"].replace(/,/g, "; ");
                            param["speakerTextStyleStr"] = param["speakerTextStyleStr"].replace(/,/g, "; ");
                            param["speakerTextStyleStr"] = param["speakerTextStyleStr"].replace(/[{}']/g, "");

                            var output = mustache.render(
                                this.createSpeakerTemplate(
                                    param["speakerImgStyle"],
                                    param["speakerTextStyleStr"],
                                    param["speakerTemplate"],
                                    speaker,
                                    param["speakerImgBasedOn"],
                                    param["speakerBanner"]
                                ),
                                speaker
                            );

                            const modalData: Object = {
                                speakerModalHeader: param["speakerModalHeader"],
                                modalContent: output,
                                speakerData: {
                                    id: speaker.id,
                                    speakerFirstName: speaker.firstName,
                                    speakerLastName: speaker.lastName
                                }
                            };

                            param["modalService"].setModalData(modalData, "myModal", true);
                            param["modalService"].open("myModal", false);
                        }
                    },
                    (err) => {
                        param["modalService"].close("sessionModal");
                        const modalData: Object = {
                            modalContent: "Unable to load speaker data"
                        };

                        param["modalService"].setModalData(modalData, "myModal", true);
                        param["modalService"].open("myModal", false);
                    }
                );
            }

            openLINK(event,url) {
                event.preventDefault();
                event.stopPropagation(); 
                if(url && url != null) {
                    window.open(url, "_blank");
                } else {
                    param["_flashMessagesService"].show("No URL Provided.", { 
                        cssClass: "alert-danger"
                    });
                    return false;
                }
            }

            preventModal(event) {
                event.preventDefault();
                event.stopPropagation(); 
            }

            checkInstances(statusId, isAllowed) {
                return (statusId == 6 && isAllowed == "true") ? true : false;
            }

            showAllInstances(event, sessionId, instanceId) {
                event.stopPropagation();
                var filter: any = {};
                filter["sessionIds"] = [sessionId];
                param["attendeeSessionService"].getSessions(filter).subscribe((resp) => {
                    param["modalService"].close("sessionModal");
                    if (resp.body != null && resp.body["sessions"].length > 0) {
                        let otherSessions = [];
                        this.sharedService.updateDateTime(resp.body["sessions"], param['filterConfig'].selectTimezone);
                        resp.body["sessions"].forEach((element) => {
                            if (element.id != instanceId) {
                                otherSessions.push(element);
                            }
                        });
                        if (otherSessions.length == 0) {
                            param["_flashMessagesService"].show("There are no other session instances.", {
                                cssClass: "alert-danger"
                            });
                            return false;
                        }
                        var idx = 1;
                        var sessionList = {
                            sessions: otherSessions,
                            formatStartDate: function() {
                                return function(date, render) {
                                    return param["datePipe"].transform(
                                        render(date).replace(new RegExp(" ", "g"), "T"),
                                        "MMM d, yyyy, h:mm a"
                                    );
                                };
                            },
                            formatEndDate: function() {
                                return function(date, render) {
                                    return param["datePipe"].transform(
                                        render(date).replace(new RegExp(" ", "g"), "T"),
                                        "h:mm a"
                                    );
                                };
                            },
                            idx: function() {
                                return idx++;
                            },
                            index: function() {
                                return idx;
                            }
                        };

                        var output = mustache.render(
                            '{@ddf.#sessions@}<div class="row instance-container"><div class="col-sm-1 instance-index-container" title="{@ddf.instanceCode@}">{@ddf.idx@}</div><div class="col-sm-11 instance-details-container" title="{@ddf.instanceCode@}"><strong>Date & Time: </strong>{@ddf.#formatStartDate@}{@ddf.startTime@}{@ddf./formatStartDate@} - {@ddf.#formatEndDate@}{@ddf.endTime@}{@ddf./formatEndDate@} <br><strong>Location:</strong> {@ddf.locationName@}</div></div>{@ddf./sessions@}',
                            sessionList
                        );
                        const modalData: Object = {
                            modalContent: output
                        };
                        param["modalService"].setModalData(modalData, "instanceModal", true);
                        param["modalService"].open("instanceModal", false);
                    } else {
                        param["_flashMessagesService"].show("There are no session instance(s) for this session.", {
                            cssClass: "alert-danger"
                        });
                        return false;
                    }
                });
            }
            isNotProcessingSession = Object.assign([], param["toggle"]);
            showAddToCart = Object.assign([], param["showAddToCart"]);
            showRecurrenceText = Object.assign([], param["showRecurrenceText"]);
            addSessionToCart(event, instanceId, index, addToFavourite: boolean, sessionId) {
                event.stopPropagation();
                if (!this.isNotProcessingSession[index]) {
                    return false;
                }
                this.isNotProcessingSession[index] = false;
                param["sharedService"].showLoader = false;

                if (addToFavourite) {
                    var cartObjbect = {
                        registrationUUID: param["loggedInAttendee"].uuid,
                        confSessionInstanceId: instanceId,
                        catalogUUID: param["sharedService"].setup.uuid,
                        sessionId: sessionId
                    };
                    param["attendeeSessionService"].addToCart(cartObjbect, param['generalSessionConfig']?.catalogConfig?.instanceCheckValidation).subscribe(
                        (resp) => {
                            if (resp["body"].hasOwnProperty("registrationConfSessionInstanceCartDTO")) {
                                this.showAddToCart[index] = false;
                                this.isNotProcessingSession[index] = true;
                                param["sharedService"].showLoader = true;
                            }
                        },
                        (err) => {
                            param["_flashMessagesService"].show(err.error.errorResponse.errors[0], {
                                cssClass: "alert-danger"
                            });
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                        }
                    );
                } else {
                    param["attendeeSessionService"].processFav(param["loggedInAttendee"].uuid, instanceId).subscribe(
                        (resp) => {
                            if (resp["body"].hasOwnProperty("status") && resp["body"].status == "200") {
                                this.showAddToCart[index] = false;
                                this.isNotProcessingSession[index] = true;
                                param["sharedService"].showLoader = true;
                            }
                        },
                        (err) => {
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                        }
                    );
                }
            }

            isEnrolled = Object.assign([], param["isEnrolled"]);
            isViewOnly = Object.assign([], param["isViewOnly"]);
            isWaitListed = Object.assign([], param["isWaitListed"]);
            isGoingToBeWaitlisted = Object.assign([], param["isGoingToBeWaitlisted"]);
            showButton = Object.assign([], param["showButton"]);
            registerSession(event, instanceId, index, addToFavourite: boolean, startTime, endTime, sessionId) {
                let session = sessionList.sessions.find(obj => {
                    return obj.id == instanceId
                })
                startTime = param.datePipe.transform(
                    startTime.replace(new RegExp(" ", "g"), "T"),
                    'EE, MMMM dd' +
                        " , " +
                        param.generalDataConfig.dateTimeFormats.timeFormat
                );

                endTime = param.datePipe.transform(
                    endTime.replace(new RegExp(" ", "g"), "T"),
                        param.generalDataConfig.dateTimeFormats.timeFormat
                ); 
                event.stopPropagation();
                if (!this.isNotProcessingSession[index]) {
                    return false;
                }
                this.isNotProcessingSession[index] = false;
                param["sharedService"].showLoader = false;
                var cartObjbect = {
                    registrationUUID: param["loggedInAttendee"].uuid,
                    confSessionInstanceId: instanceId,
                    catalogUUID: param["sharedService"].setup.uuid,
                    sessionId: sessionId
                };
                param["attendeeSessionService"].addToCart(cartObjbect, param['generalSessionConfig']?.catalogConfig?.instanceCheckValidation).subscribe(
                    (resp) => {
                        if (resp["body"].hasOwnProperty("registrationConfSessionInstanceCartDTO")) {
                            param["attendeeSessionService"].processCart(param["loggedInAttendee"].uuid, param['generalSessionConfig']?.catalogConfig?.instanceCheckValidation).subscribe(
                                (response) => {
                                    this.isNotProcessingSession[index] = true;
                                    param["sharedService"].showLoader = true;
                                    if(param['isLoggedIn']) {
                                        param.loadScript();
                                    }
                                    if (response.body.failed.length > 0) {
                                        for (let i = 0; i < response.body.failed.length; ++i) {
                                            if (response.body.failed[i] + "" === instanceId) {
                                                if(response.body.data[instanceId].includes('Not Allowed to select more than')) {
                                                    param["_flashMessagesService"].show(response.body.data[instanceId], {
                                                        cssClass: "alert-danger"
                                                    });
                                                    return
                                                }

                                                //SCM-51886 Update the code to display customized error with model ui instead of simple string
                                                var custErrorNotifyTitle = "Sessions Time Conflict Error";
                                                if(!('customizedError' in param['generalSessionConfig'].catalogConfig)) {
                                                    param['generalSessionConfig'].catalogConfig.customizedError = `<div>This session <strong> <span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.sessionTitle@}</span></strong></div><div><strong><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">({@ddf.startDateTime@} - {@ddf.endDateTime@})&nbsp;</span></strong> is conflicting with other session's in same time intervals</div>`
                                                    custErrorNotifyTitle = "Sessions Date/Time Conflict Error";
                                                }
                                                param['generalSessionConfig'].catalogConfig.customizedError = param['generalSessionConfig'].catalogConfig.customizedError.replace(
                                                    new RegExp("{@ddf.sessionDetails@}","g"),
                                                    session.sessionTitle + ": (" + startTime + " - " + endTime + ")"
                                                );

                                                // Replace startDateTime with startTime and endDateTime with end Time
                                                param['generalSessionConfig'].catalogConfig.customizedError = param['generalSessionConfig'].catalogConfig.customizedError.replace(
                                                    new RegExp("{@ddf.startDateTime@}","g"),
                                                    ""+startTime
                                                );
                        
                                                param['generalSessionConfig'].catalogConfig.customizedError = param['generalSessionConfig'].catalogConfig.customizedError.replace(
                                                    new RegExp("{@ddf.endDateTime@}","g"),
                                                    ""+endTime
                                                );

                                                var customizedErrorMessage = mustache.render(param['generalSessionConfig'].catalogConfig.customizedError, session);

                                                // Time conflict error alert while resigtering a session to registration
                                                const pnotify = param['notifyService'].getPNotify();
                                                pnotify.error({
                                                    title: custErrorNotifyTitle,
                                                    text: customizedErrorMessage,
                                                    addClass: "c-pnotify-alert",
                                                    hide: false,
                                                    textTrusted: true,
                                                    modules: {
                                                        Confirm: {
                                                            confirm: true,
                                                            align: "flex-end",
                                                            buttons: [
                                                                {
                                                                    text: "Ok",
                                                                    textTrusted: false,
                                                                    addClass: "",
                                                                    primary: true,
                                                                    promptTrigger: true,
                                                                    click: (notice, value) => {
                                                                        notice.close();
                                                                        notice.fire("pnotify.cancel", { notice, value });
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        Buttons: {
                                                            closer: true,
                                                            sticker: false
                                                        }
                                                    },
                                                    stack: {
                                                        modal: true
                                                    }
                                                });
                                                // param["_flashMessagesService"].show(customizedErrorMessage, {
                                                //     cssClass: "alert-danger",
                                                //     timeout: 7000
                                                // });
                                                return;
                                            }
                                        }
                                    }
                                    if (response.body.registered.length > 0) {
                                        for (let i = 0; i < response.body.registered.length; ++i) {
                                            if (response.body.registered[i] + "" === instanceId) {
                                                this.isEnrolled[index] = true;
                                                this.showAddToCart[index] = false;
                                                this.registrationSessionStatusId[index] = 1;
                                                return;
                                            }
                                        }
                                    }
                                    if (response.body.waitlisted.length > 0) {
                                        for (let i = 0; i < response.body.waitlisted.length; ++i) {
                                            if (response.body.waitlisted[i] + "" === instanceId) {
                                                this.isWaitListed[index] = true;
                                                this.showAddToCart[index] = false;
                                                this.registrationSessionStatusId[index] = 5;
                                                return;
                                            }
                                        }
                                    }
                                },
                                (err) => {
                                    param["sharedService"].showLoader = true;
                                    this.isNotProcessingSession[index] = true;
                                    param["_flashMessagesService"].show(err?.error?.errorResponse?.errors[0], {
                                        cssClass: "alert-danger"
                                    });
                                }
                            );
                        } else {
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                        }
                    },
                    (err) => {
                        param["_flashMessagesService"].show(err.error.errorResponse.errors[0], {
                            cssClass: "alert-danger"
                        });
                        this.isNotProcessingSession[index] = true;
                        param["sharedService"].showLoader = true;
                    }
                );
            }

            removeFromSchedule(event, instanceId, index) {
                event.stopPropagation();
                if (!this.isNotProcessingSession[index]) {
                    return false;
                }
                this.isNotProcessingSession[index] = false;
                param["sharedService"].showLoader = false;

                param["attendeeSessionService"]
                    .removeFromSchedule(instanceId, param["loggedInAttendee"].uuid)
                    .subscribe(
                        (resp) => {
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                            this.isWaitListed[index] = false;
                            this.registrationSessionStatusId[index] = null;
                            this.isEnrolled[index] = false;
                            this.showAddToCart[index] = true;
                        },
                        (err) => {
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                            param["_flashMessagesService"].show("Something went wrong please try again", {
                                cssClass: "alert-danger"
                            });
                        }
                    );
            }

            addToFavourite = Object.assign([], param["favFlag"]);
            registrationSessionStatusId = Object.assign([], param["registrationSessionStatusId"]);
            addSessionToFavourite(event, index, instanceId) {
                event.stopPropagation();
                var favObjbect = {
                    registrationUUID: param["loggedInAttendee"].uuid,
                    confSessionInstanceId: instanceId,
                    catalogUUID: param["sharedService"].setup.uuid
                };
                this.addToFavourite[index] = false;
                param["sharedService"].showLoader = false;
                param["attendeeSessionService"].addToFavourite(favObjbect).subscribe(
                    (resp) => {
                        param["sharedService"].showLoader = true;
                        if (resp["body"].hasOwnProperty("confSessionInstanceId")) {
                            this.addToFavourite[index] = false;
                        }
                    },
                    (err) => {}
                );
            }

            isNotExcluded = Object.assign([], param["toggle"]);
            sessionData = Object.assign([], param["sessionData"]);
            excludeSession(event, index, instanceId) {
                event.stopPropagation();

                var m = "<div>Are you sure you want to hide this session ?</div>";
                const pnotify = param["notifyService"].getPNotify();
                pnotify.alert({
                    title: "Don't show this session again.",
                    text: m,
                    addClass: "c-pnotify-confirm",
                    hide: false,
                    textTrusted: true,
                    modules: {
                        Confirm: {
                            confirm: true,
                            align: "flex-end",
                            buttons: [
                                {
                                    text: "No",
                                    textTrusted: false,
                                    addClass: "",
                                    primary: true,
                                    promptTrigger: true,
                                    click: (notice, value) => {
                                        notice.close();
                                        notice.fire("pnotify.confirm", { notice, value });
                                    }
                                },
                                {
                                    text: "Yes",
                                    textTrusted: false,
                                    addClass: "",
                                    primary: true,
                                    promptTrigger: true,
                                    click: (notice, value) => {
                                        var excObjbect = {
                                            registrationUUID: param["loggedInAttendee"].uuid,
                                            confSessionInstanceId: instanceId,
                                            isExcluded: true
                                        };
                                        param["sharedService"].showLoader = false;

                                        if (
                                            this.sessionData[index + 1] == true &&
                                            this.sessionData[index - 1] == true &&
                                            this.isNotExcluded[index + 1] == true &&
                                            this.isNotExcluded[index - 1] == true
                                        ) {
                                            //its between sessions
                                        } else if (
                                            this.sessionData[index - 1] == true &&
                                            this.isNotExcluded[index - 1] == true
                                        ) {
                                            //its below sessions
                                        } else if (
                                            this.sessionData[index - 1] == false &&
                                            this.sessionData[index + 1] == false
                                        ) {
                                            //it has grouping heading and is only one in it
                                            for (let i = index - 1; i >= 0; --i) {
                                                if (this.sessionData[i] == true) {
                                                    break;
                                                } else {
                                                    //to hide heading
                                                    this.isNotExcluded[i] = false;
                                                }
                                            }
                                        } else if (
                                            this.isNotExcluded[index - 1] == false &&
                                            this.sessionData[index - 1] == true
                                        ) {
                                            //the session above is exculed so loop to heading
                                            for (let i = index - 2; i >= 0; --i) {
                                                if (this.sessionData[i] == true && this.isNotExcluded[i] == true) {
                                                    //its between sessions
                                                    break;
                                                } else {
                                                    //to hide heading
                                                    this.isNotExcluded[i] = false;
                                                }
                                            }
                                        }
                                        //to hide session
                                        this.isNotExcluded[index] = false;
                                        if (param["sharedService"].hasOwnProperty("excData")) {
                                            param["sharedService"].excData.size += 1;
                                        } else {
                                            param["sharedService"]["excData"].size = 1;
                                        }
                                        param["sharedService"]["excData"].instanceId.push(parseInt(instanceId)) 
                                        if (
                                            param["sharedService"].excData.size ===
                                            param["sharedService"].totalCountOfGeneralSessions
                                        ) {
                                            param["sharedService"].allSessionsHidden = true;
                                            param["sharedService"].onScroll();
                                        }

                                        param["attendeeSessionService"].addToFavourite(excObjbect).subscribe(
                                            (resp) => {
                                                param["sharedService"].showLoader = true;
                                                // if (resp["body"].hasOwnProperty("confSessionInstanceId")) {
                                                //     if (
                                                //         this.sessionData[index + 1] == true &&
                                                //         this.sessionData[index - 1] == true &&
                                                //         this.isNotExcluded[index + 1] == true &&
                                                //         this.isNotExcluded[index - 1] == true
                                                //     ) {
                                                //         //its between sessions
                                                //     } else if (
                                                //         this.sessionData[index - 1] == true &&
                                                //         this.isNotExcluded[index - 1] == true
                                                //     ) {
                                                //         //its below sessions
                                                //     } else if (
                                                //         this.sessionData[index - 1] == false &&
                                                //         this.sessionData[index + 1] == false
                                                //     ) {
                                                //         //it has grouping heading and is only one in it
                                                //         for (let i = index - 1; i >= 0; --i) {
                                                //             if (this.sessionData[i] == true) {
                                                //                 break;
                                                //             } else {
                                                //                 //to hide heading
                                                //                 this.isNotExcluded[i] = false;
                                                //             }
                                                //         }
                                                //     } else if (
                                                //         this.isNotExcluded[index - 1] == false &&
                                                //         this.sessionData[index - 1] == true
                                                //     ) {
                                                //         //the session above is exculed so loop to heading
                                                //         for (let i = index - 2; i >= 0; --i) {
                                                //             if (
                                                //                 this.sessionData[i] == true &&
                                                //                 this.isNotExcluded[i] == true
                                                //             ) {
                                                //                 //its between sessions
                                                //                 break;
                                                //             } else {
                                                //                 //to hide heading
                                                //                 this.isNotExcluded[i] = false;
                                                //             }
                                                //         }
                                                //     }
                                                //     //to hide session
                                                //     this.isNotExcluded[index] = false;
                                                //     if (param["sharedService"].hasOwnProperty("excData")) {
                                                //         param["sharedService"].excData.size += 1;
                                                //     } else {
                                                //         param["sharedService"]["excData"].size = 1;
                                                //     }
                                                //     if (
                                                //         param["sharedService"].excData.size ===
                                                //         param["sharedService"].totalCountOfGeneralSessions
                                                //     ) {
                                                //         param["sharedService"].allSessionsHidden = true;
                                                //         param["sharedService"].onScroll();
                                                //     }
                                                // }
                                            },
                                            (err) => {}
                                        );
                                        notice.close();
                                        notice.fire("pnotify.confirm", { notice, value });
                                    }
                                }
                            ]
                        },
                        Buttons: {
                            closer: false,
                            sticker: false
                        }
                    },
                    stack: {
                        modal: true
                    }
                });
            }

            removeSessionFromFavourite(event, index, instanceId) {
                event.stopPropagation();
                param["sharedService"].showLoader = false;
                this.addToFavourite[index] = true;
                param["attendeeSessionService"]
                    .removeFromFavourite(param["loggedInAttendee"].uuid, instanceId)
                    .subscribe(
                        (resp) => {
                            param["sharedService"].showLoader = true;
                            if (resp["body"].hasOwnProperty("status") && resp["body"].status === "200") {
                                this.addToFavourite[index] = true;
                            }
                        },
                        (err) => {}
                    );
            }

            labelClick(event) {
                event.stopPropagation();
            }

            ngOnInit() {
                /* do stuff here in the dynamic component */
                this.stopPropagate();
            }
            toggle = param["toggle"];
            toggleView(event, index) {
                event.stopPropagation();
                this.toggle[index] = !this.toggle[index];
                if(param['isLoggedIn']) {
                    param.loadScript();
                    if(this.sharedService.accountClientList && !this.sharedService.accountClientList.calAppleToggleIcon && 
                        !this.sharedService.accountClientList.calYahooToggleIcon &&
                        !this.sharedService.accountClientList.calOutlookToggleIcon &&
                        !this.sharedService.accountClientList.calGoogleToggleIcon && 
                        !this.sharedService.accountClientList.calOutlookOnlineToggleIcon &&
                        !this.sharedService.accountClientList.calOffice365ToggleIcon) {
                            $(document).ready(function(){
                                (document.querySelectorAll('.addeventatc') as any as Array<HTMLElement>).forEach((elem) => {
                                    elem.style.display = "none";
                                })
                            })
                    }
                }
                this.stopPropagate();
            }

            toggleSessionInstances(event, sessionId) {
                event.stopPropagation();
                parentCmp.childEvent.emit(sessionId);
            }

            stopPropagate() {
                $(document).ready(function(){
                    if(document.getElementById('session-section')) {
                    var links= document.getElementById('session-section').getElementsByTagName("a")
                        for (var i=0;i<links.length;i++){
                            links[i].addEventListener("click",function(e){
                            //prevent event action
                            e.stopPropagation();
                            return false;
                            })
                        }
                    }
                });
            }

            

            openModal(item) {
                let loggedInUser = sessionStorage.getItem("loggedInAttendee_" + param.sharedService.eventUUID);

                if((loggedInUser == "null" || !loggedInUser) && param['loginConfig'].isEnabled == true) {
                    let url = "";
                    if (item == "login") {
                        param.popupService.setPosition("center");
                        param.popupService.setSize("small");
                        param.popupService.togglePopup();
                        param.sharedService.currentPopup = {
                            title: null,
                            navLinks: null,
                            saveMessage: "reg-login",
                            showFooter: false
                        };
                        url = "popup/login";
                    }
                    param["modalService"].close("sessionModal");
                    param.sharedService.navigateToOutlet("popup", url);
                } 
            }

            gotoURL(ID) {
                let loggedInUser = sessionStorage.getItem("loggedInAttendee_" + param.sharedService.eventUUID);
                if(loggedInUser && loggedInUser != "null") {
                let session = sessionList.sessions.find(obj => {
                    return obj.id == ID
                  })
                // return session.webinar.webinarThumbnail || param['defaultThumbnailURL']
                let joinBaseUrl;
                if (session.regWebinar && session.regWebinar != null && session.regWebinar.participantJoinUrl != null) {
                    joinBaseUrl = session.regWebinar.participantJoinUrl;
                    window.open(joinBaseUrl, "_blank");
                  }
                }
            }

            getImage(ID) {
                let session = sessionList.sessions.find(obj => {
                    return obj.id == ID
                  })
                  let thumbnail;
                  if (session.webinar != null && session.webinar.webinarThumbnail != null) {
                    thumbnail = session.webinar.webinarThumbnail;
                  } else {
                    thumbnail = param['defaultHeaderThumbnailURL']
                  }
                return thumbnail;
            }

            getBodyImage(ID) {
                let session = sessionList.sessions.find(obj => {
                    return obj.id == ID
                  })
                  let thumbnail;
                  if (session.webinar != null && session.webinar.webinarThumbnail != null) {
                    thumbnail = session.webinar.webinarThumbnail;
                  } else {
                    thumbnail = param['defaultBodyThumbnailURL'] 
                  }
                return thumbnail;
            }

    

            findIndex(id) {
                let index = -1;
                if (param["instanceId"] != null) {
                    index = param["instanceId"].indexOf(id);
                }
                return index;
            }

            listen(message) {
                if (param["type"] == "general-") {
                    if (message.text === "single-remove-cart") {
                        let idx = this.findIndex(message.data);
                        if (idx >= 0) {
                            this.showAddToCart[idx] = true;
                            this.addToFavourite[idx] = true;
                        }
                    } else if (message.text === "single-add-cart") {
                         let idx = this.findIndex(message.data);
                         if (idx >= 0) {
                             this.showAddToCart[idx] = false;
                             this.addToFavourite[idx] = false;
                         }
                    } else if (message.text === "clear-cart") {
                        message.data.forEach((element) => {
                            let idx = this.findIndex(element);
                            if (idx >= 0) {
                                this.showAddToCart[idx] = true;
                                this.addToFavourite[idx] = true;
                            }
                        });
                    } else if (message.text === "single-add-fav") {
                        let idx = this.findIndex(message.data);
                        if (idx >= 0) {
                            this.addToFavourite[idx] = false;
                        }
                    } else if (message.text === "single-remove-fav") {
                        let idx = this.findIndex(message.data);
                        if (idx >= 0) {
                            this.addToFavourite[idx] = true;
                        }
                    } else if (message.text === "remove-all-fav") {
                        message.data.forEach((element) => {
                            let idx = this.findIndex(element);
                            if (idx >= 0) {
                                this.addToFavourite[idx] = true;
                            }
                        });
                    } else if (message.text === "single-remove-schedule") {
                        let idx = this.findIndex(message.data);
                        if (idx >= 0) {
                            this.isEnrolled[idx] = false;
                            this.isWaitListed[idx] = false;
                            this.registrationSessionStatusId[idx] = 2;
                        }
                    } else if (message.text === "move-fav-to-cart") {
                        let idx = this.findIndex(message.data);
                        if (idx >= 0) {
                            this.showAddToCart[idx] = false;
                            this.addToFavourite[idx] = true;
                        }
                    } else if (message.text === "add-all-fav-to-cart") {
                        message.data.forEach((element) => {
                            let idx = this.findIndex(element);
                            if (idx >= 0) {
                                this.showAddToCart[idx] = false;
                                this.addToFavourite[idx] = true;
                            }
                        });
                    } else if (message.text === "process-cart") {
                        if (message.data["registered"].length > 0) {
                            message.data.registered.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.isEnrolled[idx] = true;
                                    this.showAddToCart[idx] = false;
                                    this.registrationSessionStatusId[idx] = 1;
                                }
                            });
                            if(param['isLoggedIn']) {
                                param.loadScript();
                        }
                        }

                        if (message.data["waitlisted"].length > 0) {
                            message.data.waitlisted.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.isWaitListed[idx] = true;
                                    this.showAddToCart[idx] = false;
                                }
                            });
                        }

                        if (message.data["failed"].length > 0) {
                            message.data.failed.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.showAddToCart[idx] = true;
                                }
                            });
                        }
                    }
                }
            }
        }

        @Custompipe({
            name: "toDateObj"
        })
        class ToDateObj implements PipeTransform {
            transform(value: any): any {
                if (value) {
                    return value.toString().replace(new RegExp(" ", "g"), "T");
                } else {
                    return null;
                }
            }
        }

        // Now, also create a dynamic module.
        @CustomNgModule({
            imports: [RouterModule, CommonModule, CclSharedModule, TranslateModule],
            declarations: [tmpCmp, ToDateObj],
            providers: [TranslateService],
            schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
        })
        class tmpModule {}

        // Now compile this module and component, and inject it into that #generalList in your current component template.
        this.compiler.compileModuleAndAllComponentsAsync(tmpModule).then((factories) => {
            const f = factories.componentFactories.find(element => element.selector === 'scTmpCmp');
            cmpRef = f.create(this.injector, [], null, this.moduleRef);
            cmpRef.instance.name = "my-dynamic-component";
            cmpRef.instance.compiler = this.compiler;
            cmpRef.instance.sharedService = this.sharedService;
            cmpRef.instance.popupService = this.popupService;
            if (this.fromAttendee) {
                this.sharedService.generalPreviewRef = cmpRef;
                this.sharedService.generalPreviewRefRender = true;
                this.sharedService.renderView();
            } else {
                this.subscription2 = this.messageService
                    .getMessage()
                    .subscribe((message) => cmpRef.instance.listen(message));
                    if(compRef) {
                        compRef.insert(cmpRef.hostView);
                    }
                this.sharedService.showLoader = true;
                if (cmpRef?.instance?.params && cmpRef.instance.params["type"] == "general-") {
                    this.loadingList = false;
                    this.sharedService.generalListLoading = false;
                }
            }
        });
    }
}

function CustomComponent(annotation: any) {
    return function(target: Function) {
        const component = new Component(annotation);
        Component(component)(target);
    };
}

function CustomNgModule(annotation: any) {
    return function(target: Function) {
        const ngModule = new NgModule(annotation);
        NgModule(ngModule)(target);
    };
}

function Custompipe(annotation: any) {
    return function(target: Function) {
        const pipe = new Pipe(annotation);
        Pipe(pipe)(target);
    };
}

var cardPopUP= function(){
    this.dispatcher = $({});
 };
 cardPopUP.prototype = {
    some_property: null,
 
    PopUp: function(data) {
             this.some_property = data;
             this.dispatcher.trigger("PopUp");
         }
 };

 var cardpop = new cardPopUP();

